import YunexpressShipping from "./YunexpressShipping";
import FrameUnits from "./FrameUnits";
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import { Row, Col, Card, Tooltip, Dropdown } from "react-bootstrap";
import Button from "../../components/shared/buttons/button";
import { OrdersIcon } from "../../components/layout/sidebar/Sidebarsvg";
import { AngleRightSvg } from "../../svgFiles/AngleRightSvg";
import { CircleCheckSvg } from "../../svgFiles/CircleCheckSvg";
import { ApprovedCheckSvg } from "../../svgFiles/ApprovedCheckSvg";
import { ChevronDownSvg } from "../../svgFiles/ChevronDownSvg";
import { HourglassSvg } from "../../svgFiles/HourglassSvg";
import Orderstatus from "./Orderstatus";
import Glassonly from "./Glassonly";
import CustomDropdown from "../../components/shared/dropdown/CustomDropdown";
import { FileSvg } from "../../svgFiles/FileSvg";
import { AiSparkleSvg } from "../../svgFiles/AiSparkleSvg";
import { useParsePrescription } from "../../hooks/useParsePrescription";
import {
    getOrderPrescriptionFieldKeys,
} from "../../helpers/prescriptionExtract";
import {
    orderUpdatePayloadValue,
    vaPrescriptionToFormValues,
} from "../../helpers/prescriptionFormat";
import AddnoteModal from "../../components/shared/modalContent/AddnoteModal";
import EditCustomerModal from "../../components/shared/modalContent/EditCustomerModal";
import EditOrderFromModal from "../../components/shared/modalContent/EditOrderFromModal";
import { useParams } from "react-router";
import { statusesOptions } from "../enums/orderEnums";
import {
    useUpdateOrderByShopifyItemIDMutation,
    useUploadOrderPhotoMutation,
    useSendOrderToProductionMutation,
    useGetProductionOrderStatusMutation,
} from "../../app/orderApi/OrderApi";
import { useAnalyzePrescriptionMutation, useGetPrescriptionQuery } from "../../app/prescriptionApi/prescriptionApi";
import PrescriptionList from "../prescription/PrescriptionList";
import { useNavigate } from "react-router";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";
import UserInfo from "./UserInfo";
import { useRedoOrderMutation, useMarkFieldSeenMutation } from "../../app/orderApi/OrderApi";
import CopyToClipboard from "../../components/shared/copyToClipboard/CopyToClipboard";
import { glassTypeLabels, showToast, getClassByType } from "../../helpers/Utils";
import { isPanelRedemptionOrder } from "../../helpers/redemptionOrder";
import { useApproveDistributorOrderMutation, useGetodersByFilterMutation } from "../../app/orderApi/OrderApi";
import { useGetRedemptionCodesQuery } from "../../app/redemptionApi/redemptionApi";
import UserRecord from "./UserRecord";
import Loader from "../../components/shared/loader/Loader";
import { ExclamationSvg } from "../../svgFiles/ExclamationSvg";
import { CrossSvg } from "../../svgFiles/CrossSvg";
import { FileCopySvg } from "../../svgFiles/FileCopySvg";
import { ViewOrderStatusSvg } from "../../svgFiles/ViewOrderStatusSvg";
import { CancelOrderSvg } from "../../svgFiles/CancelOrderSvg";
import { UploadSvg } from "../../svgFiles/UploadSvg.jsx";
import CommonModal, { CommonModalFooter } from "../../components/shared/modalLayout/CommonModal";
import Overlay from 'react-bootstrap/Overlay';
import { useAuth } from "../auth/AuthContext";
import { hasRole as roleMatches } from "../../helpers/roleNames";
import { P } from "../../utils/permissions";
import { useOrderDetailsSocket } from "../../hooks/useOrderDetailsSocket";
import {
    resolveOrderItemProductType,
    isLensProductType,
    displayProductTypeValue,
    isUnknownProductType,
    isFrameProductType,
    isOtherProductType,
    isVaOrAudiologistChannel,
    isVaChannel,
    getOrderBundleCode,
    formatBundleDisplayLabel,
    formatBundleUnitItemDisplayId,
    groupOrderItemsByBundle,
    preferBundlePrimaryIndex,
    isCaptifyPremiumOrderLine,
    resolveOrderRedemptionCode,
    resolveVaProviderName,
} from "../../helpers/vaInvoiceUtils";

import CustomDatePicker from "../../components/shared/fields/CustomDatePicker";
import { formatDashboardDateTime } from "../../helpers/dashboardTime";
import "./order.css";

const PRODUCT_TYPE_OPTIONS = [
    { label: "Unknown", value: "unknown" },
    { label: "Frame", value: "frame" },
    { label: "Lens", value: "lens" },
    { label: "Other", value: "other" },
];

const getProductTypeOptions = () => PRODUCT_TYPE_OPTIONS;

const ORDER_RX_FIELD_KEYS = getOrderPrescriptionFieldKeys();
const AI_CORE_PRESCRIPTION_FIELDS = [
    "ODRightSphere_SPH",
    "ODRightCylinder_CYL",
    "ODRightAxis",
    "OSLeftSphere_SPH",
    "OSLeftCylinder_CYL",
    "OSLeftAxis",
];
const isBlankPrescriptionValue = (value) => value === null || value === undefined || value === "";

const formatMacAddress = (value) => {
    const compact = String(value || "").toUpperCase().replace(/[^0-9A-F]/g, "");
    return compact.length === 12 ? compact.match(/.{2}/g).join(":") : value;
};

const formatProductionStatus = (value) => {
    if (!value) return "Waiting for update";
    return String(value)
        .toLowerCase()
        .split("_")
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(" ");
};

const formatProductionTime = (value) => {
    if (!value) return null;
    return formatDashboardDateTime(value, null);
};

const isReworkItemId = (itemId) => /-F\d+$/i.test(String(itemId || ""));

const OrderDetails = () => {
    const [didInit, setDidInit] = useState(false);
    const [dirty, setDirty] = useState(false);
    const { id } = useParams();
    const { state } = useLocation();
    const navigate = useNavigate();
    const ordersListPage = useSelector((state) => state.filters.page) || 1;
    const { hasPermission, isAdmin, isVaDistributor, hasRole, roles } = useAuth();
    const canUpdateStatus = hasPermission(P.ORDERS_UPDATE_STATUS);
    const canUpdateProperties = hasPermission(P.ORDERS_UPDATE_PROPERTIES);
    // Shipping date / tracking: admin only (VA distributors must not edit).
    const canEditShipping = hasPermission(P.ORDERS_UPLOAD_TRACKING);
    const canCancelOrder = hasPermission(P.ORDERS_CANCEL) || canUpdateStatus;
    // Header "Cancel order" CTA is VA distributor and va-admin; admins cancel via status.
    const showCancelOrderButton =
        (Boolean(isVaDistributor?.()) || hasRole("va-admin")) && canCancelOrder;
    const showDistributorApproval = Boolean(isVaDistributor?.());
    const showApprovalStatus =
        roleMatches(roles, "superadmin") || roleMatches(roles, "va-admin");
    const canRedo = hasPermission(P.ORDERS_REDO);
    const canEditNotes = hasPermission(P.ORDERS_NOTES_WRITE);
    // PO number / Original PO file / Original invoice: editable for admin / va-admin / superadmin.
    const canManageVaDocs =
        Boolean(isAdmin?.()) ||
        roleMatches(roles, "superadmin") ||
        roleMatches(roles, "va-admin");
    const allowEditCustomerIdentity = Boolean(isAdmin?.());
    const [showAddnoteModal, setShowAddnoteModal] = useState(false);
    const [showEditOrderFromModal, setShowEditOrderFromModal] = useState(false);
    const [showEditCustomerModal, setShowEditCustomerModal] = useState(false);
    const [getOrders, { isLoading }] = useGetodersByFilterMutation();
    const [approveDistributorOrder] = useApproveDistributorOrderMutation();
    const [isApprovingOrder, setIsApprovingOrder] = useState(false);
    const [isSavingNote, setIsSavingNote] = useState(false);
    const [isSavingProviderName, setIsSavingProviderName] = useState(false);
    const [isSavingCustomer, setIsSavingCustomer] = useState(false);
    const [isSavingOrderFrom, setIsSavingOrderFrom] = useState(false);
    const [updateOrder] = useUpdateOrderByShopifyItemIDMutation();
    const [analyzePrescription] = useAnalyzePrescriptionMutation();
    const [uploadOrderPhoto, { isLoading: isUploadingPhoto }] = useUploadOrderPhotoMutation();
    const [sendOrderToProduction] = useSendOrderToProductionMutation();
    const [getProductionOrderStatus] = useGetProductionOrderStatusMutation();
    const [orders, setOrders] = useState([]);
    const [fieldSeen] = useMarkFieldSeenMutation()
    const [currentIndex, setCurrentIndex] = useState(0);
    const [skuUpdates, setSkuUpdates] = useState(0);
    const [isRedo, setIsRedo] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);
    const [tooltipText, setTooltipText] = useState(false);
    const target = useRef(null);
    const itemRefs = useRef([]);
    const scrollContainerRef = useRef(null);
    const dirtyRef = useRef(false);
    const currentIndexRef = useRef(0);
    const ordersRef = useRef([]);
    const silentRefreshRef = useRef(false);
    const [isSilentRefreshing, setIsSilentRefreshing] = useState(false);
    const [showRedoConfirmModal, setShowRedoConfirmModal] = useState(false);
    const [redoAction, setRedoAction] = useState(null);
    const [keepPrescriptionAndMountType, setKeepPrescriptionAndMountType] = useState(false);
    const [showStatusConfirmModal, setShowStatusConfirmModal] = useState(false);
    const [statusChangeAction, setStatusChangeAction] = useState(null);
    const [showCancelConfirmModal, setShowCancelConfirmModal] = useState(false);
    const [showApproveConfirmModal, setShowApproveConfirmModal] = useState(false);
    const [cancelConfirmText, setCancelConfirmText] = useState("");
    const [showDeliveredBlockedModal, setShowDeliveredBlockedModal] = useState(false);
    const [showProductTypeConfirmModal, setShowProductTypeConfirmModal] = useState(false);
    const [showAiExtractConfirmModal, setShowAiExtractConfirmModal] = useState(false);
    const [sendingProductionItemId, setSendingProductionItemId] = useState(null);
    const [queryingProductionItemId, setQueryingProductionItemId] = useState(null);
    const photoInputRef = useRef(null);
    const queriedProductionItemsRef = useRef(new Set());
    const analyzedPrescriptionItemsRef = useRef(new Set());
    const activePrescriptionItemIdRef = useRef(null);
    const latestPrescriptionFormRef = useRef(null);
    const { parse: parseRx, isParsing: isParsingRx } = useParsePrescription();
    const fetchOrders = useCallback(async ({ silent = false } = {}) => {
        if (silent) {
            silentRefreshRef.current = true;
            setIsSilentRefreshing(true);
        }
        try {
            const response = await getOrders({ ShopifyId: id, page: 1, limit: 1000 }).unwrap();
            const nextOrders = response?.data?.orders || [];
            setOrders(nextOrders);
            return nextOrders;
        } catch (err) {
            console.error("Failed to fetch orders:", err);
            return null;
        } finally {
            if (silent) {
                silentRefreshRef.current = false;
                setIsSilentRefreshing(false);
            }
        }
    }, [getOrders, id]);

    const handleOrderPhotoChange = async (event) => {
        const photo = event.target.files?.[0];
        event.target.value = "";
        if (!photo || !currentOrder?.ItemID) return;
        if (!photo.type.startsWith("image/")) {
            showToast("Please select an image file.", "error");
            return;
        }
        if (photo.size > 10 * 1024 * 1024) {
            showToast("Photo must be smaller than 10MB.", "error");
            return;
        }

        try {
            const isFrame = isFrameProductType(currentOrder?.ProductType);
            const response = await uploadOrderPhoto({ ItemID: currentOrder.ItemID, photo }).unwrap();
            const uploadedPhoto = isFrame ? response?.data?.photo : response?.data;
            const frameMAC = response?.data?.frameMAC || "";
            const frameSN = response?.data?.frameSN || "";
            setOrders((previous) => previous.map((order) => (
                order.ItemID === currentOrder.ItemID
                    ? {
                        ...order,
                        ...(isFrame ? { FrameMAC: frameMAC, FrameSN: frameSN } : {}),
                        ...(uploadedPhoto ? { orderPhotos: [...(order.orderPhotos || []), uploadedPhoto] } : {}),
                    }
                    : order
            )));
            if (isFrame) {
                setformdata((previous) => previous.ItemID === currentOrder.ItemID
                    ? { ...previous, FrameMAC: frameMAC, FrameSN: frameSN }
                    : previous);
            }
            showToast(isFrame ? "Frame photo analyzed successfully." : "Lens photo uploaded successfully.", "success");
        } catch (error) {
            console.error("Order photo upload failed:", error);
            showToast(error?.data?.message || "Unable to upload order photo.", "error");
        }
    };

    const handleSendToProduction = async (order, provider, resend = false) => {
        if (!order?.ItemID || sendingProductionItemId) return;
        if (resend && !window.confirm(`Send ${order.ItemID} again to ${provider}? Confirm the previous supplier will not continue production. Previous dispatch records will be retained.`)) return;
        if (!resend && order.Redo && !window.confirm(
            `${order.ItemID} is marked for redo. Send this item to ${provider}? Please check whether its rework item has already been sent to avoid duplicate production.`
        )) return;
        setSendingProductionItemId(order.ItemID);
        try {
            const response = await sendOrderToProduction({ ItemID: order.ItemID, provider, resend }).unwrap();
            const productionAssignment = response?.data?.productionAssignment;
            if (productionAssignment) {
                setOrders((previous) => previous.map((item) => (
                    item.ItemID === order.ItemID ? { ...item, productionAssignment, ...(resend ? { productionProcesses: [], productionExpress: [] } : {}) } : item
                )));
            }
            showToast(provider === "ARTS" ? "Queued for Arts pickup. Awaiting acknowledgement." : `Sent to ${provider} successfully.`, "success");
        } catch (error) {
            console.error("Send to production failed:", error);
            showToast(error?.data?.message || `Unable to send to ${provider}.`, "error");
            await fetchOrders({ silent: true });
        } finally {
            setSendingProductionItemId(null);
        }
    };

    useEffect(() => {
        dirtyRef.current = dirty;
    }, [dirty]);

    useEffect(() => {
        currentIndexRef.current = currentIndex;
    }, [currentIndex]);

    useEffect(() => {
        ordersRef.current = orders;
    }, [orders]);

    useEffect(() => {
        fetchOrders({ silent: false });
        // Only re-fetch when the route ShopifyId changes (not when mutation fn identity changes).
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    /**
     * Soft-refresh this order when Shopify/dashboard pushes order:updated
     * for the open ShopifyId. Always refetch so cancel/shipping locks update
     * in realtime (even while the form is dirty). Index/form jumps only when clean.
     */
    const handleSocketOrderMatch = useCallback(async (payload) => {
        // Optimistic lock from socket payload (admin ship) before API round-trip.
        const nextStatus =
            payload?.Status ?? payload?.data?.Status ?? payload?.order?.Status;
        const nextTracking =
            payload?.TrackingNumber ??
            payload?.data?.TrackingNumber ??
            payload?.order?.TrackingNumber;
        const nextShipDate =
            payload?.ShipDate ?? payload?.data?.ShipDate ?? payload?.order?.ShipDate;

        if (
            nextStatus != null ||
            nextTracking != null ||
            nextShipDate != null
        ) {
            setOrders((prev) =>
                (Array.isArray(prev) ? prev : []).map((order) => ({
                    ...order,
                    ...(nextStatus != null ? { Status: Number(nextStatus) } : {}),
                    ...(nextTracking != null
                        ? { TrackingNumber: String(nextTracking) }
                        : {}),
                    ...(nextShipDate != null ? { ShipDate: nextShipDate } : {}),
                }))
            );
        }

        const previousItemId = ordersRef.current[currentIndexRef.current]?.ItemID;
        const nextOrders = await fetchOrders({ silent: true });
        if (!nextOrders?.length) return;

        // Keep editing session intact; orders[] already refreshed for cancel lock.
        if (dirtyRef.current) return;

        if (previousItemId) {
            const nextIndex = nextOrders.findIndex(
                (order) => String(order.ItemID) === String(previousItemId)
            );
            if (nextIndex !== -1) {
                setCurrentIndex(nextIndex);
            }
        }
    }, [fetchOrders]);

    useOrderDetailsSocket({
        shopifyId: id,
        enabled: Boolean(id),
        onMatch: handleSocketOrderMatch,
    });

    useEffect(() => {
        if (!didInit && orders.length > 0 && !isLoading) {
            let initialIndex = -1;
            const currentItemId = state?.ItemID;
            if (currentItemId) {
                initialIndex = orders.findIndex(order => order.ItemID === currentItemId);
            }
            if (initialIndex === -1 && state?.fromRedemption) {
                initialIndex = orders.findIndex(order =>
                    /premium/i.test(order.SkuName || "")
                );
            }
            setCurrentIndex(initialIndex !== -1 ? initialIndex : 0);
            setDidInit(true);
        }
    }, [orders, isLoading, state?.ItemID, state?.fromRedemption, didInit]);

    // useEffect(() => {
    //     const scrollContainer = scrollContainerRef.current;

    //     const handleScroll = () => {
    //         if (!scrollContainer || dirty) return; // Don't change item while editing
    //         const { scrollTop, scrollHeight, clientHeight } = scrollContainer;

    //         // Check if scrolled to the top
    //         if (scrollTop === 0) {
    //             setCurrentIndex(0);
    //             return;
    //         }

    //         // Check if scrolled to the bottom (with a 1px tolerance)
    //         if (scrollHeight - scrollTop - clientHeight < 1) {
    //             setCurrentIndex(orders.length - 1);
    //             return;
    //         }
    //     };

    //     const observer = new IntersectionObserver(
    //         (entries) => {
    //             entries.forEach((entry) => {
    //                 if (entry.isIntersecting) {
    //                     const index = parseInt(entry.target.dataset.index, 10);
    //                     if (!isNaN(index) && index > 0 && index < orders.length - 1 && !dirty) {
    //                         setCurrentIndex(index);
    //                     }
    //                 }
    //             });
    //         },
    //         {
    //             rootMargin: "-50% 0px -50% 0px", // Creates a 0-height horizontal line at the vertical center
    //             threshold: 0,
    //         }
    //     );

    //     const currentItemRefs = itemRefs.current;
    //     currentItemRefs.forEach((ref, index) => {
    //         // Only observe items that are not the first or the last
    //         if (ref && index > 0 && index < orders.length - 1) {
    //             observer.observe(ref);
    //         }
    //     });

    //     if (scrollContainer) {
    //         scrollContainer.addEventListener('scroll', handleScroll);
    //     }

    //     return () => {
    //         currentItemRefs.forEach((ref, index) => {
    //             if (ref) observer.unobserve(ref);
    //         });
    //         observer.disconnect();
    //         if (scrollContainer) {
    //             scrollContainer.removeEventListener('scroll', handleScroll);
    //         }
    //     };
    // }, [orders, dirty]); // Reruns when orders are loaded or when dirty state changes

    const currentOrder = orders[currentIndex] || null;

    useEffect(() => {
        const assignment = currentOrder?.productionAssignment;
        const itemId = currentOrder?.ItemID;
        const supportsStatusQuery = ["PP", "YUFENG"].includes(assignment?.provider)
            && assignment?.externalOrderNo;
        if (!supportsStatusQuery || !itemId || queriedProductionItemsRef.current.has(itemId)) return;

        queriedProductionItemsRef.current.add(itemId);
        setQueryingProductionItemId(itemId);
        getProductionOrderStatus({ ItemID: itemId }).unwrap()
            .then((response) => {
                const data = response?.data;
                if (!data?.productionAssignment) return;
                setOrders((previous) => previous.map((item) => (
                    item.ItemID === itemId
                        ? { ...item, Status: data.Status ?? item.Status, productionAssignment: data.productionAssignment }
                        : item
                )));
            })
            .catch((error) => {
                console.error("Unable to query production status:", error);
                showToast(error?.data?.message || "Unable to query production status.", "error");
            })
            .finally(() => setQueryingProductionItemId(null));
    }, [
        currentOrder?.ItemID,
        currentOrder?.productionAssignment?.provider,
        currentOrder?.productionAssignment?.externalOrderNo,
        getProductionOrderStatus,
    ]);
    const isRedemptionPanelOrder =
        isPanelRedemptionOrder(id) || isPanelRedemptionOrder(currentOrder);

    const isBundleOrderView = useMemo(() => {
        if (!orders?.length) return false;
        if (!isVaOrAudiologistChannel(orders[0])) return false;
        return orders.some((order) => Boolean(getOrderBundleCode(order)));
    }, [orders]);

    const bundleGroups = useMemo(
        () => (isBundleOrderView ? groupOrderItemsByBundle(orders) : []),
        [isBundleOrderView, orders]
    );

    const activeBundleGroup = useMemo(() => {
        if (!isBundleOrderView || !bundleGroups.length) return null;
        return (
            bundleGroups.find((group) => group.indices.includes(currentIndex)) ||
            bundleGroups[0]
        );
    }, [isBundleOrderView, bundleGroups, currentIndex]);

    // Determine the frame and lens based on the currently selected item
    let frameOrder, lensOrder;
    if (isLensProductType(currentOrder?.ProductType)) {
        lensOrder = currentOrder;
        // Find the corresponding frame item.
        frameOrder = orders.find((order) => isFrameProductType(order.ProductType));
    } else if (isFrameProductType(currentOrder?.ProductType)) {
        frameOrder = currentOrder;
        // Find the first associated lens item.
        lensOrder = orders.find((order) => isLensProductType(order.ProductType));
    } else {
        // For items that are not a frame or lens (e.g., missing type, other)
        // treat them as the primary item and don't auto-link a lens.
        frameOrder = currentOrder;
        lensOrder = null;
    }
    const fetchData = async () => {
        try {
            await fieldSeen({
                body: {
                    ItemID: currentOrder?.ItemID,
                }
            }).unwrap();

        } catch (err) {
            console.error("Error:", err);
        }
    };

    const pendingScrollIndexRef = useRef(null);

    const getNearestScrollParent = useCallback((el) => {
        let node = el?.parentElement;
        while (node && node !== document.body) {
            const { overflowY } = window.getComputedStyle(node);
            if (
                (overflowY === "auto" ||
                    overflowY === "scroll" ||
                    overflowY === "overlay") &&
                node.scrollHeight > node.clientHeight + 1
            ) {
                return node;
            }
            node = node.parentElement;
        }
        return document.scrollingElement || document.documentElement;
    }, []);

    // Keep side rails / scroll targets clear of the sticky breadcrumbs bar.
    const syncStickyHeaderOffset = useCallback(() => {
        const headerEl =
            document.querySelector(
                ".order-details-page-container > .order-details-header"
            ) || document.querySelector(".order-details-header");
        const shell = document.querySelector(".admin-shell-order-details");
        const headerHeight = Math.ceil(
            headerEl?.getBoundingClientRect().height ?? 76
        );
        if (shell) {
            shell.style.setProperty(
                "--order-details-sticky-header-height",
                `${headerHeight}px`
            );
        }
        return headerHeight + 12;
    }, []);

    // Align the selected card to the top of the scroll area (below sticky breadcrumbs).
    const scrollCardIntoView = useCallback(
        (index) => {
            const card = itemRefs.current[index];
            if (!card) return false;

            const scrollParent =
                card.closest(".order-details-page-wrapper") ||
                document.querySelector(".order-details-page-wrapper") ||
                getNearestScrollParent(card);

            const stickyOffset = syncStickyHeaderOffset();
            card.style.scrollMarginTop = `${stickyOffset}px`;

            if (
                !scrollParent ||
                scrollParent === document.scrollingElement ||
                scrollParent === document.documentElement ||
                scrollParent === document.body
            ) {
                card.scrollIntoView({ behavior: "smooth", block: "start" });
                return true;
            }

            const parentRect = scrollParent.getBoundingClientRect();
            const cardRect = card.getBoundingClientRect();
            const targetTop =
                scrollParent.scrollTop +
                (cardRect.top - parentRect.top) -
                stickyOffset;

            scrollParent.scrollTo({
                top: Math.max(0, targetTop),
                behavior: "smooth",
            });
            return true;
        },
        [getNearestScrollParent, syncStickyHeaderOffset]
    );

    useEffect(() => {
        syncStickyHeaderOffset();
        const headerEl =
            document.querySelector(
                ".order-details-page-container > .order-details-header"
            ) || document.querySelector(".order-details-header");
        if (!headerEl || typeof ResizeObserver === "undefined") return undefined;
        const observer = new ResizeObserver(() => syncStickyHeaderOffset());
        observer.observe(headerEl);
        return () => observer.disconnect();
    }, [syncStickyHeaderOffset]);

    // Scroll after selection re-renders (card height can change when active).
    useEffect(() => {
        const index = pendingScrollIndexRef.current;
        if (index == null || index !== currentIndex) return undefined;

        const timers = [
            window.setTimeout(() => scrollCardIntoView(index), 0),
            window.setTimeout(() => scrollCardIntoView(index), 80),
            window.setTimeout(() => {
                scrollCardIntoView(index);
                pendingScrollIndexRef.current = null;
            }, 220),
        ];

        return () => timers.forEach((id) => window.clearTimeout(id));
    }, [currentIndex, scrollCardIntoView]);

    // After initial index is determined, scroll into view (e.g. page refresh).
    useEffect(() => {
        if (!didInit || !orders.length || currentIndex <= 0) return undefined;
        const timer = window.setTimeout(() => {
            scrollCardIntoView(currentIndex);
        }, 100);
        return () => window.clearTimeout(timer);
    }, [didInit, orders.length, scrollCardIntoView]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleNavClick = (index) => {
        pendingScrollIndexRef.current = index;
        setCurrentIndex(index);
        // Same item already selected — still force scroll to top of that card.
        if (index === currentIndex) {
            window.requestAnimationFrame(() => scrollCardIntoView(index));
        }
    };

    useEffect(() => {
        setIsRedo(!!currentOrder?.Redo);
    }, [currentOrder?.Redo]);
    useEffect(() => {
        if (currentOrder) {

            fetchData()
        }
    }, [currentOrder])

    const [selectedOption, setSelectedOption] = useState("Two");
    const [initialRedo, setInitialRedo] = useState(currentOrder?.Redo || null);
    const [undoOrder] = useRedoOrderMutation()
    const [disabledRedo, setDisabledRedo] = useState(Boolean(currentOrder?.Redo));
    const baseUrl = import.meta.env.VITE_API_TRACKING_URL;
    const trackingUrl = baseUrl && id ? `${baseUrl}/status?id=${id}` : "";

    const [formdata, setformdata] = useState({
        ItemID: null,
        ShopifyItemID: null,
        Status: "",
        LensMountType: "",
        CaptifyVersion: "",
        ODRightSphere_SPH: "",
        OSLeftSphere_SPH: "",
        ODRightCylinder_CYL: "",
        OSLeftCylinder_CYL: "",
        ODRightAxis: "",
        OSLeftAxis: "",
        ODRightPrism: "",
        OSLeftPrism: "",
        ODRightADD: "",
        OSLeftPupillaryDistance_PD: "",
        ODRightPupillaryDistance_PD: "",
        PDOneorTwoNumbers: selectedOption | null,
        SingularPDValue: "",
        LensList: "",
        Note: "",
        OrderFrom: "",
        ShipDate: undefined,
        TrackingNumber: undefined,
        FrameMAC: "",
        FrameSN: "",
        Redo: "",
    });

    const handleDiscardChanges = () => {
        if (currentOrder) {
            let latestTracking = {};
            if (Array.isArray(currentOrder?.Tracking) && currentOrder?.Tracking.length > 0) {
                const sortedTracking = [...currentOrder.Tracking].sort(
                    (a, b) => new Date(b.Date || b.updatedAt) - new Date(a.Date || a.updatedAt)
                );
                latestTracking = sortedTracking[0] || {};
            }

            const baseData = {
                ...(frameOrder || {}),
                ...(lensOrder || {}),
                ItemID: currentOrder?.ItemID || null,
                Status: currentOrder?.Status,
                // Prescription fields from API so dropdowns reflect latest saved values
                ODRightSphere_SPH: currentOrder?.ODRightSphere_SPH ?? "",
                ODRightCylinder_CYL: currentOrder?.ODRightCylinder_CYL ?? "",
                ODRightAxis: currentOrder?.ODRightAxis ?? "",
                ODRightPrism: currentOrder?.ODRightPrism ?? "",
                ODRightADD: currentOrder?.ODRightADD ?? "",
                OSLeftSphere_SPH: currentOrder?.OSLeftSphere_SPH ?? "",
                OSLeftCylinder_CYL: currentOrder?.OSLeftCylinder_CYL ?? "",
                OSLeftAxis: currentOrder?.OSLeftAxis ?? "",
                OSLeftPrism: currentOrder?.OSLeftPrism ?? "",
                OSLeftADD: currentOrder?.OSLeftADD ?? "",
                ODRightPupillaryDistance_PD: currentOrder?.ODRightPupillaryDistance_PD ?? "",
                OSLeftPupillaryDistance_PD: currentOrder?.OSLeftPupillaryDistance_PD ?? "",
                PDOneorTwoNumbers: currentOrder?.PDOneorTwoNumbers || selectedOption,
                SingularPDValue: currentOrder?.SingularPDValue ?? "",
                ShipDate: latestTracking.ShipDate || "",
                TrackingNumber: latestTracking.Number || latestTracking.TrackingNumber || latestTracking.trackingNumber || "",
                FrameMAC: currentOrder?.FrameMAC || "",
                FrameSN: currentOrder?.FrameSN || "",
                Note: currentOrder?.Note || "",
                OrderFrom:
                    currentOrder?.OrderFrom ??
                    currentOrder?.orderFrom ??
                    "",
                distributorId:
                    currentOrder?.distributorId ||
                    currentOrder?.DistributorId ||
                    currentOrder?.assignedDistributorId ||
                    "",
            };
            setformdata(baseData);
            setChangedFields(new Set());
            setDirty(false);
            setInitialRedo(null);
            setDisabledRedo(false);
            const orderForPD = (isLensProductType(currentOrder.ProductType) ? currentOrder : lensOrder) || currentOrder;
            setSelectedOption(orderForPD?.PDOneorTwoNumbers || ""); // Reset PD option

        }
    };
    const [changedFields, setChangedFields] = useState(new Set());

    activePrescriptionItemIdRef.current = currentOrder?.ItemID || null;
    latestPrescriptionFormRef.current = formdata;

    useEffect(() => {
        const itemChanged = currentOrder?.ItemID !== formdata.ItemID;
        if (currentOrder && (itemChanged || !dirty)) { // Update if item changed OR if not dirty
            const orderForPD = (isLensProductType(currentOrder.ProductType) ? currentOrder : lensOrder) || currentOrder;
            setSelectedOption(orderForPD?.PDOneorTwoNumbers);

            // Tracking is order-wide: derive latest tracking/ship date from ALL items, not just the current one
            const allTrackingEntriesForOrder = orders.flatMap((o) => o.Tracking || []);
            const {
                number: latestTrackingNumberValue,
                date: latestShipDateValue,
            } = getLatestTrackingInfoForOrder(allTrackingEntriesForOrder);

            const baseData = {
                ...(frameOrder || {}),
                ...(lensOrder || {}),
                ItemID: currentOrder?.ItemID || null,
                ProductType: displayProductTypeValue(
                    currentOrder?.ProductType ||
                    resolveOrderItemProductType(currentOrder)
                ),
                CaptifyVersion: currentOrder?.CaptifyVersion || "Unknown",
                Status: currentOrder?.Status,
                // Prescription fields from API so dropdowns reflect latest saved values
                ODRightSphere_SPH: currentOrder?.ODRightSphere_SPH ?? "",
                ODRightCylinder_CYL: currentOrder?.ODRightCylinder_CYL ?? "",
                ODRightAxis: currentOrder?.ODRightAxis ?? "",
                ODRightPrism: currentOrder?.ODRightPrism ?? "",
                ODRightADD: currentOrder?.ODRightADD ?? "",
                OSLeftSphere_SPH: currentOrder?.OSLeftSphere_SPH ?? "",
                OSLeftCylinder_CYL: currentOrder?.OSLeftCylinder_CYL ?? "",
                OSLeftAxis: currentOrder?.OSLeftAxis ?? "",
                OSLeftPrism: currentOrder?.OSLeftPrism ?? "",
                OSLeftADD: currentOrder?.OSLeftADD ?? "",
                ODRightPupillaryDistance_PD: currentOrder?.ODRightPupillaryDistance_PD ?? "",
                OSLeftPupillaryDistance_PD: currentOrder?.OSLeftPupillaryDistance_PD ?? "",
                PDOneorTwoNumbers: orderForPD?.PDOneorTwoNumbers || selectedOption,
                SingularPDValue: currentOrder?.SingularPDValue ?? "",
                ShipDate: latestShipDateValue,
                TrackingNumber: latestTrackingNumberValue,
                FrameMAC: currentOrder?.FrameMAC || "",
                FrameSN: currentOrder?.FrameSN || "",
                Note: currentOrder?.Note || "",
                OrderFrom: currentOrder?.OrderFrom ?? currentOrder?.orderFrom ?? "",
                distributorId:
                    currentOrder?.distributorId ||
                    currentOrder?.DistributorId ||
                    currentOrder?.assignedDistributorId ||
                    "",
            };

            setformdata(baseData);

            // Reset Redo selectbox state on order change
            setInitialRedo(currentOrder?.Redo || null); // Use the active item for redo
            setDisabledRedo(Boolean(currentOrder?.Redo));

            if (itemChanged) {
                setDirty(false);
                setChangedFields(new Set());
            }

            // Sku updates should be for the specific lens item being displayed
            const relevantLensOrder = isLensProductType(currentOrder.ProductType) ? currentOrder : lensOrder;
            const skuUpdates = (relevantLensOrder?.ChangeLog || []).filter(({ field }) => field === "SkuName");
            setSkuUpdates(skuUpdates);
        }
    }, [currentOrder, orders, frameOrder, lensOrder, dirty, formdata.ItemID]);

    // Always fetch the "Progressive Lenses" configuration to show all possible fields.
    const { data: prescriptionData, error } = useGetPrescriptionQuery(
        { prescriptionType: "Progressive Lenses" },

    );

    useEffect(() => {
        const order = currentOrder;
        if (!order || formdata.ItemID !== order.ItemID || dirty || isUpdating) return;
        if (!isLensProductType(order.ProductType) || !order.prescriptionFile) return;
        if (order.Redo || order.isRemoved || order.isReturned || order.Status === 999) return;
        const needsCorePrescription = AI_CORE_PRESCRIPTION_FIELDS.some(
            (field) => isBlankPrescriptionValue(order[field])
        );
        if (!needsCorePrescription || analyzedPrescriptionItemsRef.current.has(order.ItemID)) return;

        analyzedPrescriptionItemsRef.current.add(order.ItemID);
        analyzePrescription({ ItemID: order.ItemID }).unwrap()
            .then((response) => {
                if (activePrescriptionItemIdRef.current !== order.ItemID || dirtyRef.current) return;
                const extractedValues = response?.data?.values || {};
                const latestFormdata = latestPrescriptionFormRef.current || {};
                const fillableValues = Object.fromEntries(
                    Object.entries(extractedValues).filter(([field, value]) => (
                        ORDER_RX_FIELD_KEYS.includes(field)
                        && !isBlankPrescriptionValue(value)
                        && isBlankPrescriptionValue(latestFormdata[field])
                    ))
                );
                const filledFields = Object.keys(fillableValues);
                if (response?.data?.requiresReview || !filledFields.length) return;
                setformdata((previous) => ({ ...previous, ...fillableValues }));
                setChangedFields((previous) => new Set([...previous, ...filledFields]));
                if (fillableValues.PDOneorTwoNumbers) {
                    setSelectedOption(fillableValues.PDOneorTwoNumbers);
                }
                setDirty(true);
                showToast(`AI filled ${filledFields.length} prescription fields. Please review and save.`, "success");
            })
            .catch((analysisError) => {
                if (activePrescriptionItemIdRef.current === order.ItemID) {
                    console.error("Automatic prescription analysis failed:", analysisError);
                }
            });
    }, [analyzePrescription, currentOrder, dirty, formdata.ItemID, isUpdating]);



    const handleSelect = (fieldName, selectedOption) => {
        let value;
        if (selectedOption && typeof selectedOption === 'object' && 'value' in selectedOption) {
            value = selectedOption.value;
        } else if (selectedOption && typeof selectedOption === 'object') {
            value = selectedOption.label || selectedOption;
        } else {
            value = selectedOption;
        }

        // If switching to "Lens" from an unknown/empty type, we want to
        // PREFILL any existing prescription data from the order instead of
        // wiping it out to 0.00 everywhere.
        const isNewLens = fieldName === 'ProductType' && value?.toLowerCase() === 'lens' && !isLensProductType(currentOrder?.ProductType);

        let extraFields = {};

        if (isNewLens) {
            setSelectedOption("Two");

            // Prefer the lens item (if currentOrder is a frame) otherwise use currentOrder itself.
            const rxSource = (isLensProductType(currentOrder?.ProductType) ? currentOrder : (lensOrder || currentOrder)) || {};

            const hasRx =
                rxSource.ODRightSphere_SPH != null ||
                rxSource.ODRightCylinder_CYL != null ||
                rxSource.ODRightAxis != null ||
                rxSource.OSLeftSphere_SPH != null ||
                rxSource.OSLeftCylinder_CYL != null ||
                rxSource.OSLeftAxis != null ||
                rxSource.ODRightADD != null ||
                rxSource.OSLeftADD != null ||
                rxSource.ODRightPupillaryDistance_PD != null ||
                rxSource.OSLeftPupillaryDistance_PD != null;

            if (hasRx) {
                // Use existing prescription values from the API response
                extraFields = {
                    ODRightSphere_SPH: rxSource.ODRightSphere_SPH ?? "",
                    ODRightCylinder_CYL: rxSource.ODRightCylinder_CYL ?? "",
                    ODRightAxis: rxSource.ODRightAxis ?? "",
                    ODRightADD: rxSource.ODRightADD ?? "",
                    OSLeftSphere_SPH: rxSource.OSLeftSphere_SPH ?? "",
                    OSLeftCylinder_CYL: rxSource.OSLeftCylinder_CYL ?? "",
                    OSLeftAxis: rxSource.OSLeftAxis ?? "",
                    OSLeftADD: rxSource.OSLeftADD ?? "",
                    ODRightPupillaryDistance_PD: rxSource.ODRightPupillaryDistance_PD ?? "",
                    OSLeftPupillaryDistance_PD: rxSource.OSLeftPupillaryDistance_PD ?? "",
                    PDOneorTwoNumbers: rxSource.PDOneorTwoNumbers || "Two",
                    SingularPDValue: rxSource.SingularPDValue ?? "",
                };
            } else {
                // No Rx on this item yet – start clean
                extraFields = {
                    ODRightSphere_SPH: "", ODRightCylinder_CYL: "", ODRightAxis: "", ODRightADD: "", ODRightPupillaryDistance_PD: "",
                    OSLeftSphere_SPH: "", OSLeftCylinder_CYL: "", OSLeftAxis: "", OSLeftADD: "", OSLeftPupillaryDistance_PD: "",
                    SingularPDValue: "", PDOneorTwoNumbers: "Two"
                };
            }
        }

        setformdata(prev => ({
            ...prev,
            [fieldName]: value,
            ...extraFields,
        }));

        setChangedFields(prev => new Set(prev).add(fieldName));
        setDirty(true);
    };

    const handleInputChange = (fieldName, value) => {
        setformdata(prev => ({
            ...prev,
            [fieldName]: value
        }));
        setChangedFields(prev => new Set(prev).add(fieldName));
        setDirty(true);
    };

    const handleNoteSave = async (noteValue) => {
        const itemIdToUpdate = formdata?.ItemID || currentOrder?.ItemID;
        if (!itemIdToUpdate || isSavingNote) return;

        const nextNote = String(noteValue ?? "");
        const currentNote = String(
            formdata?.Note ?? currentOrder?.Note ?? ""
        );
        if (nextNote === currentNote) {
            setShowAddnoteModal(false);
            return;
        }

        try {
            setIsSavingNote(true);
            const result = await updateOrder({
                ItemID: itemIdToUpdate,
                Note: nextNote,
            }).unwrap();
            showToast(
                result?.message || "Notes saved.",
                result?.type || "success"
            );

            setformdata((prev) => ({ ...prev, Note: nextNote }));
            setChangedFields((prev) => {
                const next = new Set(prev);
                next.delete("Note");
                setDirty(next.size > 0 || Boolean(initialRedo));
                return next;
            });

            const response = await getOrders({
                ShopifyId: id,
                page: 1,
                limit: 1000,
            }).unwrap();
            const updatedOrders = response?.data?.orders || [];
            setOrders(updatedOrders);
            const updatedIndex = updatedOrders.findIndex(
                (order) => order.ItemID === itemIdToUpdate
            );
            if (updatedIndex !== -1) {
                setCurrentIndex(updatedIndex);
            }
            setShowAddnoteModal(false);
        } catch (error) {
            showToast(
                error?.data?.message || "Unable to save notes.",
                "error"
            );
        } finally {
            setIsSavingNote(false);
        }
    };

    const applyAiExtractedPrescription = (extracted) => {
        const nextValues = vaPrescriptionToFormValues(extracted);
        const pdType = nextValues.PDOneorTwoNumbers || null;
        const fieldsApplied = [];

        ORDER_RX_FIELD_KEYS.forEach((field) => {
            if (field === "PDOneorTwoNumbers") return;
            const value = nextValues[field];
            if (value !== null && value !== undefined) {
                fieldsApplied.push(field);
            }
        });
        if (pdType) {
            fieldsApplied.push("PDOneorTwoNumbers");
        }

        setformdata((prev) => {
            const next = { ...prev };
            fieldsApplied.forEach((field) => {
                if (field === "PDOneorTwoNumbers") {
                    next.PDOneorTwoNumbers = pdType;
                    return;
                }
                next[field] = nextValues[field];
            });
            return next;
        });

        if (pdType) {
            setSelectedOption(pdType);
        }

        if (fieldsApplied.length) {
            setChangedFields((prev) => {
                const next = new Set(prev);
                fieldsApplied.forEach((field) => next.add(field));
                return next;
            });
            setDirty(true);
        }
    };

    const runAiPrescriptionExtraction = async () => {
        const fileUrl =
            (currentOrder?.ItemID === formdata?.ItemID
                ? currentOrder?.prescriptionFile
                : null) ||
            orders?.[currentIndex]?.prescriptionFile ||
            currentOrder?.prescriptionFile;

        if (!fileUrl) {
            showToast("No prescription file found for this item.", "error");
            return;
        }

        try {
            // Server downloads the S3 file (browser fetch hits CORS).
            const extracted = await parseRx({
                prescriptionFileUrl: fileUrl,
            });
            applyAiExtractedPrescription(extracted);
            showToast("Prescription values filled from AI extraction.", "success");
        } catch (err) {
            showToast(
                err?.data?.message ||
                    err?.message ||
                    "Could not read prescription. Try again.",
                "error"
            );
        }
    };

    const handleAiExtractionClick = () => {
        if (isParsingRx) return;
        // Always confirm first — extraction fills/overwrites prescription fields.
        setShowAiExtractConfirmModal(true);
    };

    const handleAiExtractConfirm = async () => {
        setShowAiExtractConfirmModal(false);
        await runAiPrescriptionExtraction();
    };

    const refreshOrdersAfterModalSave = async (itemIdToUpdate) => {
        const response = await getOrders({
            ShopifyId: id,
            page: 1,
            limit: 1000,
        }).unwrap();
        const updatedOrders = response?.data?.orders || [];
        setOrders(updatedOrders);
        if (!itemIdToUpdate) return;
        const updatedIndex = updatedOrders.findIndex(
            (order) => order.ItemID === itemIdToUpdate
        );
        if (updatedIndex !== -1) {
            setCurrentIndex(updatedIndex);
        }
    };

    const clearChangedFields = (fieldNames = []) => {
        setChangedFields((prev) => {
            const next = new Set(prev);
            fieldNames.forEach((field) => next.delete(field));
            setDirty(next.size > 0 || Boolean(initialRedo));
            return next;
        });
    };

    /** Immediate save from edit modals — no second Save bar click. */
    const handleCustomerSave = async (fields) => {
        if (!fields || Object.keys(fields).length === 0) {
            setShowEditCustomerModal(false);
            return;
        }
        const itemIdToUpdate = formdata?.ItemID || currentOrder?.ItemID;
        if (!itemIdToUpdate || isSavingCustomer) return;

        try {
            setIsSavingCustomer(true);
            const payload = { ItemID: itemIdToUpdate, ...fields };
            const result = await updateOrder(payload).unwrap();
            showToast(
                result?.message || "Customer information saved.",
                result?.type || "success"
            );
            setformdata((prev) => ({ ...prev, ...fields }));
            clearChangedFields(Object.keys(fields));
            await refreshOrdersAfterModalSave(itemIdToUpdate);
            setShowEditCustomerModal(false);
        } catch (error) {
            showToast(
                error?.data?.message || "Unable to save customer information.",
                "error"
            );
        } finally {
            setIsSavingCustomer(false);
        }
    };

    const handleProviderNameSave = async (value) => {
        const providerName = String(value || "").trim();
        if (!providerName || isSavingProviderName) return;

        const itemIdToUpdate = formdata?.ItemID || currentOrder?.ItemID;
        if (!itemIdToUpdate) return;

        const currentProvider = resolveVaProviderName(
            formdata?.ItemID === currentOrder?.ItemID
                ? { ...currentOrder, ...formdata }
                : currentOrder
        );
        if (providerName === currentProvider) {
            return;
        }

        try {
            setIsSavingProviderName(true);
            const fields = {
                providerName,
                vaAudiologistName: providerName,
            };
            const result = await updateOrder({
                ItemID: itemIdToUpdate,
                ...fields,
            }).unwrap();
            showToast(
                result?.message || "Provider name saved.",
                result?.type || "success"
            );
            setformdata((prev) => ({ ...prev, ...fields }));
            clearChangedFields(Object.keys(fields));
            await refreshOrdersAfterModalSave(itemIdToUpdate);
        } catch (error) {
            showToast(
                error?.data?.message || "Unable to save Provider name.",
                "error"
            );
            throw error;
        } finally {
            setIsSavingProviderName(false);
        }
    };

    const handleOrderFromSave = async ({ orderFrom, distributorId } = {}) => {
        const nextOrderFrom = String(orderFrom || "").trim();
        if (!nextOrderFrom || isSavingOrderFrom) return;

        const itemIdToUpdate = formdata?.ItemID || currentOrder?.ItemID;
        if (!itemIdToUpdate) return;

        const currentOrderFrom = String(
            formdata?.OrderFrom ||
                currentOrder?.OrderFrom ||
                currentOrder?.orderFrom ||
                ""
        ).trim();
        if (nextOrderFrom === currentOrderFrom) {
            setShowEditOrderFromModal(false);
            return;
        }

        try {
            setIsSavingOrderFrom(true);
            const result = await updateOrder({
                ItemID: itemIdToUpdate,
                OrderFrom: nextOrderFrom,
            }).unwrap();
            showToast(
                result?.message || "Order from saved.",
                result?.type || "success"
            );
            setformdata((prev) => ({
                ...prev,
                OrderFrom: nextOrderFrom,
                ...(distributorId ? { distributorId } : {}),
            }));
            clearChangedFields(["OrderFrom"]);
            await refreshOrdersAfterModalSave(itemIdToUpdate);
            setShowEditOrderFromModal(false);
        } catch (error) {
            showToast(
                error?.data?.message || "Unable to save Order from.",
                "error"
            );
        } finally {
            setIsSavingOrderFrom(false);
        }
    };

    const getEffectiveItemStatus = (order) => {
        if (
            order?.ItemID &&
            formdata?.ItemID &&
            order.ItemID === formdata.ItemID &&
            changedFields.has("Status")
        ) {
            return Number(formdata.Status);
        }
        return Number(order?.Status);
    };

    const allActiveItemsAreShipped = () => {
        const activeItems = (orders || []).filter(
            (order) => !order?.isRemoved && !order?.isReturned && Number(order?.Status) !== 999
        );
        if (!activeItems.length) return false;
        return activeItems.every((order) => {
            const status = getEffectiveItemStatus(order);
            return status === 6 || status === 7;
        });
    };

    const handleStatusChangeRequest = (option) => {
        const statusValue = Number(option);
        if (statusValue === 7 && !allActiveItemsAreShipped()) {
            setShowDeliveredBlockedModal(true);
            return;
        }
        if (statusValue === 999) {
            openCancelConfirmModal();
            return;
        }
        if (statusValue === 6 || statusValue === 7) {
            setStatusChangeAction({ status: statusValue });
            setShowStatusConfirmModal(true);
        } else {
            handleSelect("Status", statusValue);
        }
    };

    const normalizeOrderNumberInput = (value) =>
        String(value || "")
            .trim()
            .replace(/^#/, "");

    const orderNumberForCancel = normalizeOrderNumberInput(
        currentOrder?.BackerID ?? ""
    );

    const isOrderAlreadyShipped = (() => {
        const postShippingStatuses = new Set([6, 7, 8]);
        const list = Array.isArray(orders) ? orders : [];
        return list.some((order) => {
            // Match backend assertCancelAllowedForOrder — ignore inactive lines.
            if (
                order?.isRemoved === true ||
                order?.isReturned === true ||
                Number(order?.Status) === 999
            ) {
                return false;
            }
            if (postShippingStatuses.has(Number(order?.Status))) {
                return true;
            }
            if (String(order?.TrackingNumber || "").trim()) {
                return true;
            }
            if (order?.ShipDate) {
                return true;
            }
            return false;
        });
    })();

    const VA_DISTRIBUTOR_CANCEL_STATUSES = new Set([0, 1, 2]);
    // Early cancel window (00/01/02) is for VA distributor / va-admin only.
    // Admin (and other full status editors) may cancel at any status.
    const usesEarlyCancelWindow =
        Boolean(isVaDistributor?.()) || hasRole("va-admin");
    const isVaDistributorCancelAllowed = (() => {
        if (!usesEarlyCancelWindow) return true;
        const list = Array.isArray(orders) ? orders : [];
        const activeItems = list.filter(
            (order) =>
                order?.isRemoved !== true &&
                order?.isReturned !== true &&
                Number(order?.Status) !== 999
        );
        return (
            activeItems.length > 0 &&
            activeItems.every((order) =>
                VA_DISTRIBUTOR_CANCEL_STATUSES.has(Number(order?.Status))
            )
        );
    })();

    const isOrderCancelled = Number(currentOrder?.Status) === 999;

    useEffect(() => {
        if (isVaDistributorCancelAllowed || !showCancelConfirmModal) return;
        setShowCancelConfirmModal(false);
        setCancelConfirmText("");
        showToast(
            "This order can only be cancelled while every item is still status 00, 01, or 02.",
            "error"
        );
    }, [isVaDistributorCancelAllowed, showCancelConfirmModal]);

    const cancelConfirmMatches =
        Boolean(orderNumberForCancel) &&
        normalizeOrderNumberInput(cancelConfirmText) === orderNumberForCancel;

    const isDemoOrder =
        currentOrder?.isDemo === true ||
        (orders || []).some(
            (order) =>
                order?.isDemo === true &&
                (String(order?.BackerID || "") ===
                    String(currentOrder?.BackerID || "") ||
                    String(order?.ShopifyId || "") ===
                        String(currentOrder?.ShopifyId || id || ""))
        );

    // Legacy Shopify orders store codes in RedemptionCode collection (not on Order).
    // Reuse admin list API — no backend change.
    const shopifyIdForRedemptionLookup = String(
        currentOrder?.ShopifyId || id || ""
    ).trim();
    const canLookupShopifyRedemptionCodes =
        Boolean(shopifyIdForRedemptionLookup) &&
        !isVaChannel(currentOrder) &&
        !isDemoOrder &&
        !isRedemptionPanelOrder &&
        !isVaDistributor?.() &&
        (Boolean(isAdmin?.()) ||
            roleMatches(roles, "superadmin") ||
            !Array.isArray(roles) ||
            roles.length === 0);
    const { data: shopifyRedemptionLookup } = useGetRedemptionCodesQuery(
        {
            search: shopifyIdForRedemptionLookup,
            page: 1,
            limit: 50,
        },
        { skip: !canLookupShopifyRedemptionCodes }
    );
    const shopifyRedemptionRows = useMemo(() => {
        const rows = shopifyRedemptionLookup?.data?.codes || [];
        return rows.filter(
            (row) =>
                String(row?.shopifyOrderId || "").trim() ===
                shopifyIdForRedemptionLookup
        );
    }, [shopifyRedemptionLookup, shopifyIdForRedemptionLookup]);
    const shopifyActivationCodes = useMemo(
        () =>
            [
                ...new Set(
                    shopifyRedemptionRows
                        .map((row) => String(row?.code || "").trim())
                        .filter(Boolean)
                ),
            ],
        [shopifyRedemptionRows]
    );
    const shopifyCodeByLineItemId = useMemo(() => {
        const map = new Map();
        for (const row of shopifyRedemptionRows) {
            const lineId = String(row?.shopifyLineItemId || "").trim();
            const code = String(row?.code || "").trim();
            if (!lineId || !code || map.has(lineId)) continue;
            map.set(lineId, code);
        }
        return map;
    }, [shopifyRedemptionRows]);

    const distributorApprovalStatus =
        currentOrder?.distributorApprovalStatus === "approved" ? "approved" : "pending";

    const handleApproveDistributorOrder = async () => {
        const itemId = currentOrder?.ItemID;
        if (
            !itemId ||
            isDemoOrder ||
            isApprovingOrder ||
            distributorApprovalStatus === "approved"
        ) {
            return false;
        }
        try {
            setIsApprovingOrder(true);
            const result = await approveDistributorOrder({
                ShopifyId: currentOrder?.ShopifyId || id,
                ItemID: itemId,
            }).unwrap();
            showToast(result?.message || "Order approved.", result?.type || "success");
            const approvalRecord = result?.data?.approvalRecord;
            setOrders((current) =>
                (current || []).map((order) => {
                    if (String(order?.ShopifyId) !== String(currentOrder?.ShopifyId)) {
                        return order;
                    }
                    return {
                        ...order,
                        distributorApprovalStatus: "approved",
                        Record: approvalRecord
                            ? [...(order.Record || []), approvalRecord]
                            : order.Record,
                    };
                })
            );
            return true;
        } catch (error) {
            showToast(error?.data?.message || "Unable to approve order.", "error");
            return false;
        } finally {
            setIsApprovingOrder(false);
        }
    };

    const openApproveConfirmModal = () => {
        if (
            isDemoOrder ||
            distributorApprovalStatus === "approved" ||
            isApprovingOrder
        ) {
            return;
        }
        setShowApproveConfirmModal(true);
    };

    const handleApproveConfirm = async () => {
        const approved = await handleApproveDistributorOrder();
        if (approved) setShowApproveConfirmModal(false);
    };

    const openCancelConfirmModal = () => {
        if (isOrderCancelled) {
            showToast("This order is already cancelled.", "error");
            return;
        }
        if (!isVaDistributorCancelAllowed) {
            showToast(
                "This order can only be cancelled while every item is still status 00, 01, or 02.",
                "error"
            );
            return;
        }
        setCancelConfirmText("");
        setShowCancelConfirmModal(true);
    };

    const closeCancelConfirmModal = () => {
        setShowCancelConfirmModal(false);
        setCancelConfirmText("");
    };

    const handleCancelOrderConfirm = async () => {
        if (!cancelConfirmMatches) return;
        const itemIdToUpdate = formdata?.ItemID || currentOrder?.ItemID;
        if (!itemIdToUpdate) {
            showToast("Unable to cancel order: missing item id", "error");
            return;
        }
        try {
            setIsUpdating(true);
            const result = await updateOrder({
                ItemID: itemIdToUpdate,
                Status: 999,
            }).unwrap();
            showToast(result?.message, result?.type);
            const response = await getOrders({
                ShopifyId: id,
                page: 1,
                limit: 1000,
            }).unwrap();
            const updatedOrders = response?.data?.orders || [];
            setOrders(updatedOrders);
            const updatedIndex = updatedOrders.findIndex(
                (order) => order.ItemID === itemIdToUpdate
            );
            if (updatedIndex !== -1) {
                setCurrentIndex(updatedIndex);
            }
            setChangedFields(new Set());
            setDirty(false);
            closeCancelConfirmModal();
        } catch (error) {
            showToast(error?.data?.message || error?.message, "error");
        } finally {
            setIsUpdating(false);
        }
    };

    const handleStatusConfirm = () => {
        if (statusChangeAction) {
            handleSelect("Status", statusChangeAction.status);
        }
        setShowStatusConfirmModal(false);
        setStatusChangeAction(null);
    };


    const handleUpdateRedo = async () => {
        try {
            setIsUpdating(true);
            setDirty(true);

            // Use ItemID from formdata to ensure we update the correct item, not based on currentIndex
            const itemIdToUpdate = formdata?.ItemID;
            const result = await undoOrder({
                redoType: initialRedo,
                keepPrescriptionAndMountType: keepPrescriptionAndMountType,
                ItemID: itemIdToUpdate,
            }).unwrap()
            console.log(result, "result")
            showToast(result?.message, result?.type)
            // Refresh orders after successful update
            await fetchOrders();
        }
        catch (error) {
            showToast(error?.data?.message, "error")
            setIsUpdating(false);
            setDirty(false);

        } finally {
            setIsUpdating(false);
            setDirty(false);

        }
    }

    const isSettingProductTypeForFirstTime = () => {
        const originalType = currentOrder?.ProductType;
        const nextType = formdata?.ProductType;
        return (
            changedFields.has("ProductType") &&
            isUnknownProductType(originalType) &&
            Boolean(nextType) &&
            !isUnknownProductType(nextType)
        );
    };

    const handleSaveRequest = () => {
        if (initialRedo) {
            handleUpdateRedo();
            return;
        }
        if (isSettingProductTypeForFirstTime()) {
            setShowProductTypeConfirmModal(true);
            return;
        }
        handleUpdate();
    };

    const handleProductTypeSaveConfirm = () => {
        setShowProductTypeConfirmModal(false);
        handleUpdate();
    };

    const selectedProductTypeLabel =
        PRODUCT_TYPE_OPTIONS.find(
            (opt) =>
                opt.value &&
                String(opt.value).toLowerCase() ===
                String(displayProductTypeValue(formdata?.ProductType) || "").toLowerCase()
        )?.label || formdata?.ProductType;

    const handleUpdate = async () => {
        try {
            // Same as TrackingNumber: ShipDate can only be submitted when status is Shipped (6)
            if (changedFields.has("ShipDate") && Number(formdata.Status) !== 6) {
                showToast("Please select Shipped status before updating shipping date", "error");
                return;
            }
            const hasPdValue =
                formdata.ODRightPupillaryDistance_PD || formdata.OSLeftPupillaryDistance_PD || formdata.SingularPDValue;
            if (hasPdValue && !formdata.PDOneorTwoNumbers) {
                showToast("Please select PD type (One or Two) when PD values are entered.", "error");
                return;
            }
            setIsUpdating(true);
            setDirty(true);
            // Use ItemID from formdata to ensure we update the correct item, not based on currentIndex
            const itemIdToUpdate = formdata?.ItemID;
            if (itemIdToUpdate) {
                const payload = { ItemID: itemIdToUpdate };
                // const shippingKeys = ["ShipDate", "TrackingNumber"];
                // const statusIs6 = formdata.Status === 6;
                // if (formdata.Status !== undefined) {
                //     payload.Status = formdata.Status;
                // }
                changedFields.forEach(field => {
                    if (formdata[field] === undefined) return;
                    const value = orderUpdatePayloadValue(field, formdata[field]);
                    if (value === undefined) return;
                    payload[field] = value;
                });
                // if (statusIs6) {
                //     shippingKeys.forEach(key => {
                //         payload[key] = formdata[key];
                //     });
                // }
                const result = await updateOrder(payload).unwrap();
                showToast(result?.message, result?.type)
                const response = await getOrders({ ShopifyId: id, page: 1, limit: 1000 }).unwrap();
                const updatedOrders = response?.data?.orders || [];
                setOrders(updatedOrders);
                // Use the captured itemIdToUpdate instead of currentOrder.ItemID
                const updatedIndex = updatedOrders.findIndex(order => order.ItemID === itemIdToUpdate);
                if (updatedIndex !== -1) {
                    setCurrentIndex(updatedIndex);
                }
                setChangedFields(new Set());
            }
        } catch (error) {
            // Even if there's an error, we should re-fetch to get the latest state
            // as some parts of the update might have succeeded.
            const response = await getOrders({ ShopifyId: id, page: 1, limit: 1000 }).unwrap();
            setOrders(response?.data?.orders || []);

            showToast(error?.data?.message, "error")
            setIsUpdating(false);
            setDirty(false);
            console.error("Failed to update order:", error);
        } finally {
            setIsUpdating(false);
            setDirty(false);

        }
    };

    const handleRedoConfirm = (keepData) => {
        setShowRedoConfirmModal(false);
        if (redoAction) {
            setKeepPrescriptionAndMountType(keepData);
            setInitialRedo(redoAction.redoType);
            setDisabledRedo(true);
            setDirty(true);
        }
    };

    const handleReturnRedo = async (order) => {
        if (!order?.isReturned || !order?.ItemID) return;
        const productType = String(order.ProductType || "").toLowerCase();
        const skuName = String(order.SkuName || "").toLowerCase();
        const redoType = productType === "lens"
            ? "L"
            : productType === "frame"
                ? "G"
                : skuName.includes("sunglass")
                    ? "S"
                    : skuName.includes("charging")
                        ? "C"
                        : null;
        if (!redoType) {
            showToast("This item type cannot be returned for rework.", "error");
            return;
        }
        try {
            setIsUpdating(true);
            const result = await undoOrder({
                ItemID: order.ItemID,
                redoType,
                keepPrescriptionAndMountType: true,
            }).unwrap();
            showToast(result?.message || "Item returned for rework.", result?.type || "success");
            setDirty(false);
            setChangedFields(new Set());
            await fetchOrders({ silent: true });
        } catch (error) {
            await fetchOrders({ silent: true });
            showToast(error?.data?.message || "Unable to return item for rework.", "error");
        } finally {
            setIsUpdating(false);
        }
    };

    const handleSelectRedo = (value) => {
        if (value === 'L' || value === 'F') {
            const hasActiveLensItem = orders.some(
                (o) =>
                    o.ProductType?.toLowerCase() === "lens" &&
                    !o.isRemoved &&
                    !o.isReturned &&
                    Number(o.Status) !== 999
            );
            if (!hasActiveLensItem) {
                setInitialRedo(value);
                setDisabledRedo(true);
                setDirty(true);
                return;
            }
            setRedoAction({ redoType: value });
            setShowRedoConfirmModal(true);
        } else if (value) {
            setInitialRedo(value);
            setDisabledRedo(true);
            setDirty(true);
        } else {
            setInitialRedo(null);
            setDisabledRedo(false);
            // Check if other fields are dirty before setting dirty to false
            if (changedFields.size === 0) {
                setDirty(false);
            }
        }
    };

    const hasSunglass = currentOrder?.SkuName?.toLowerCase().includes("sunglass");

    // const isShowFileds = currentOrder?.ProductType !== "frame" && !hasSunglass;
    const isShowFileds = isLensProductType(currentOrder?.ProductType);
    const normalizeDate = (dateStr) => {
        if (!dateStr) return "";

        // Case: contains "T" → ISO datetime
        if (dateStr.includes("T")) {
            return new Date(dateStr).toISOString().split("T")[0];
        }

        const parts = dateStr.split("-");
        if (parts.length === 3) {
            // Check if first part is YYYY or DD
            if (parts[0].length === 4) {
                // Already YYYY-MM-DD
                const [yyyy, mm, dd] = parts;
                return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
            } else {
                // Assume DD-MM-YYYY
                const [dd, mm, yyyy] = parts;
                return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
            }
        }

        // Fallback: try parsing with Date
        const parsed = new Date(dateStr);
        if (!isNaN(parsed)) {
            return parsed.toISOString().split("T")[0];
        }

        return "";
    };
    const handleCopyUrl = () => {
        if (!trackingUrl) return;

        navigator.clipboard.writeText(trackingUrl);
        setTooltipText(true);

        setTimeout(() => {
            setTooltipText(false);
        }, 1000); // hides tooltip after 2 seconds
    };

    const getLatestTrackingInfoForOrder = (trackingArray) => {
        if (!Array.isArray(trackingArray) || trackingArray.length === 0) {
            return { number: "", date: "" };
        }

        // Find the latest tracking entry based on when it was added to the DB (using updatedAt)
        const sortedByUpdatedAt = [...trackingArray].sort(
            (a, b) => new Date(b.updatedAt || b.Date) - new Date(a.updatedAt || a.Date)
        );
        const latestEntry = sortedByUpdatedAt[0] || {};

        const number =
            latestEntry.TrackingNumber ||
            latestEntry.Number ||
            latestEntry.trackingNumber ||
            "";

        const date = latestEntry.ShipDate || "";

        return { number, date };
    };

    // Latest shipping date across ALL items in this order – same value in every item's Shipping field so it never blanks
    const allTrackingEntries = orders?.flatMap((o) => o.Tracking || []) || [];
    const { date: latestShipDateAcrossOrder } = getLatestTrackingInfoForOrder(allTrackingEntries);
    console.log(latestShipDateAcrossOrder, "latestShipDateAcrossOrder")

    const statusToConfirm = statusChangeAction ? statusesOptions.find(s => s.value == statusChangeAction.status) : null;

    // Name / shipping live on every line item; pick the richest values across the order
    // so VA/admin don't see stale data when only one ItemID was updated earlier.
    const sharedCustomerFields = useMemo(() => {
        const fields = [
            "customerName",
            "customerEmail",
            "patientName",
            "provider",
            "providerName",
            "ShippingName",
            "Address1",
            "Address2",
            "ShippingCity",
            "ShippingProvince",
            "ShippingProvinceCode",
            "ShippingZip",
            "ShippingCountry",
            "ShippingPhone",
            "vaShipToRaw",
            "vaClinicName",
            "vaHospitalName",
            "vaAudiologistName",
            "invoicePoNumber",
            "originalPoNumber",
            "originalPoFile",
            "originalPoFileKey",
            "originalPoFileName",
            "invoiceFile",
            "invoiceFileKey",
            "invoiceFileName",
            "Note",
            "OrderFrom",
            "Status",
        ];
        const shared = {};
        const sorted = [...(orders || [])].sort((a, b) => {
            const aTime = new Date(a?.updatedAt || a?.Modified || 0).getTime();
            const bTime = new Date(b?.updatedAt || b?.Modified || 0).getTime();
            return bTime - aTime;
        });
        for (const field of fields) {
            const hit = sorted.find((row) => {
                const value = row?.[field];
                if (field === "Status") {
                    return value !== null && value !== undefined && value !== "";
                }
                return value !== null && value !== undefined && String(value).trim() !== "";
            });
            if (hit) shared[field] = hit[field];
        }
        return shared;
    }, [orders]);

    const invoicePoNumber = useMemo(() => {
        const hit = (orders || []).find((row) =>
            String(row?.invoicePoNumber || row?.originalPoNumber || "").trim()
        );
        if (!hit) return "";
        return String(hit.invoicePoNumber || hit.originalPoNumber).trim();
    }, [orders]);

    const originalPoFile = useMemo(() => {
        const hit = (orders || []).find((row) =>
            String(row?.originalPoFile || row?.originalPoFileKey || "").trim()
        );
        if (!hit) return null;
        return {
            url: String(hit.originalPoFile || hit.originalPoFileKey).trim(),
            name: String(hit.originalPoFileName || "").trim(),
        };
    }, [orders]);

    const invoiceFileMeta = useMemo(() => {
        const hit = (orders || []).find((row) =>
            String(
                row?.invoiceFile ||
                    row?.invoiceFileKey ||
                    row?.aiParseMeta?.invoiceFileKey ||
                    ""
            ).trim()
        );
        if (!hit) return null;
        return {
            url: String(
                hit.invoiceFile ||
                    hit.invoiceFileKey ||
                    hit.aiParseMeta?.invoiceFileKey ||
                    ""
            ).trim(),
            name: String(
                hit.invoiceFileName || hit.aiParseMeta?.invoiceFileName || ""
            ).trim(),
        };
    }, [orders]);

    const sharedProviderName = useMemo(() => {
        const sorted = [...(orders || [])].sort((a, b) => {
            const aTime = new Date(a?.updatedAt || a?.Modified || 0).getTime();
            const bTime = new Date(b?.updatedAt || b?.Modified || 0).getTime();
            return bTime - aTime;
        });
        for (const row of sorted) {
            const value = resolveVaProviderName(row);
            if (value) return value;
        }
        return "";
    }, [orders]);

    const customerOrder = useMemo(() => {
        if (!currentOrder) return currentOrder;
        const withShared = { ...currentOrder, ...sharedCustomerFields };
        const merged =
            formdata?.ItemID === currentOrder?.ItemID
                ? { ...withShared, ...formdata }
                : withShared;
        // Prefer in-progress form edits over siblings / shared snapshot.
        const providerName =
            resolveVaProviderName(merged) || sharedProviderName;
        if (providerName) {
            merged.providerName = providerName;
        }
        if (invoicePoNumber) {
            merged.invoicePoNumber = invoicePoNumber;
        }
        if (originalPoFile?.url) {
            merged.originalPoFile = originalPoFile.url;
            merged.originalPoFileKey = originalPoFile.url;
            if (originalPoFile.name) {
                merged.originalPoFileName = originalPoFile.name;
            }
        }
        if (invoiceFileMeta?.url) {
            merged.invoiceFile = invoiceFileMeta.url;
            merged.invoiceFileKey = invoiceFileMeta.url;
            if (invoiceFileMeta.name) {
                merged.invoiceFileName = invoiceFileMeta.name;
            }
        }
        if (
            shopifyActivationCodes.length > 0 &&
            !String(merged.redemptionCode || "").trim() &&
            !(
                Array.isArray(merged.redemptionCodes) &&
                merged.redemptionCodes.length > 0
            )
        ) {
            merged.redemptionCodes = shopifyActivationCodes;
            merged.redemptionCode = shopifyActivationCodes[0];
        }
        return merged;
    }, [
        currentOrder,
        sharedCustomerFields,
        sharedProviderName,
        formdata,
        invoicePoNumber,
        originalPoFile,
        invoiceFileMeta,
        shopifyActivationCodes,
    ]);

    // Merge Change Logs from every line item so VA sees Name updates made on another item.
    const changeLogOrder = useMemo(() => {
        if (!currentOrder) return currentOrder;
        const merged = [];
        const seen = new Set();
        for (const row of orders || []) {
            for (const entry of row?.Record || []) {
                const dateMs = new Date(entry?.Date || 0).getTime();
                const key = [
                    entry?.Method,
                    entry?.Data,
                    entry?.User,
                    Number.isFinite(dateMs) ? dateMs : entry?.Date,
                ].join("|");
                if (seen.has(key)) continue;
                seen.add(key);
                merged.push(entry);
            }
        }
        merged.sort((a, b) => new Date(b?.Date || 0) - new Date(a?.Date || 0));
        return { ...currentOrder, Record: merged };
    }, [currentOrder, orders]);

    return (
        <div className="order-details-page-container">
            {/* Socket soft-refresh must not show full-page Loader (looks like a reload). */}
            {(isUpdating || (isLoading && !isSilentRefreshing && orders.length === 0)) && <Loader />}

            <AddnoteModal
                show={showAddnoteModal}
                setShow={setShowAddnoteModal}
                formdata={formdata}
                onSave={handleNoteSave}
                confirmLoading={isSavingNote}
            />
            <EditOrderFromModal
                show={showEditOrderFromModal}
                setShow={setShowEditOrderFromModal}
                value={formdata?.OrderFrom || currentOrder?.OrderFrom || currentOrder?.orderFrom || ""}
                distributorId={
                    formdata?.distributorId ||
                    currentOrder?.distributorId ||
                    currentOrder?.DistributorId ||
                    currentOrder?.assignedDistributorId ||
                    ""
                }
                onSave={handleOrderFromSave}
                confirmLoading={isSavingOrderFrom}
            />
            <EditCustomerModal
                show={showEditCustomerModal}
                setShow={setShowEditCustomerModal}
                order={customerOrder}
                onSave={handleCustomerSave}
                allowEditIdentity={allowEditCustomerIdentity}
                allowEditName={canUpdateProperties}
                shippingLocked={isOrderAlreadyShipped}
                confirmLoading={isSavingCustomer}
            />
            {/* {dirty && hasUnsavedChanges() && ( */}
            {dirty && (canUpdateProperties || (initialRedo && canRedo)) && (
                <div className="submitionDiv d-flex gap-2 align-items-center">
                    <ExclamationSvg />
                    <span className="flex-grow-1">Unsaved changes</span>
                    <Button className={"px-0 py-1 justify-content-center cancel bg-white"} onClick={handleDiscardChanges} icon={<CrossSvg />} disabled={isUpdating} />
                    <Button
                        onClick={handleSaveRequest}
                        className={"px-2 py-1"}
                        label={isUpdating ? "Saving..." : "Save"}
                        icon={<CircleCheckSvg />}
                        disabled={isUpdating}
                    />
                </div>
            )}
            <div className="order-details-header">
                    <ul className="breadcrumbs p-0 d-flex gap-3 align-items-center mb-0">
                        <li role="button"
                        onClick={() => {
                            const returnPage = Number(state?.returnToOrdersPage) || ordersListPage || 1;
                            const params = new URLSearchParams();
                            if (returnPage > 1) {
                                params.set("page", String(returnPage));
                            }
                            const search = params.toString();
                            navigate(search ? `/orders?${search}` : "/orders");
                        }}
                        ><OrdersIcon />Orders</li>
                        <li><AngleRightSvg /></li>

                        <li >{currentOrder?.BackerID}</li>
                        <li >
                            {currentOrder?.isReturned ? (
                                <span className="redoOnly">Returned</span>
                        ) : currentOrder?.isRemoved ? (
                            <span className="redoOnly">Removed from Shopify</span>
                        ) : Number(currentOrder?.Status) === 999 ? (
                            <span className="class-cancelled status-badge">
                                <span className="borderBar pe-2 me-1">999</span>
                                Cancelled
                            </span>
                        ) : (
                            <span className="order-details-status-row d-inline-flex align-items-center gap-2 flex-nowrap">
                                {canUpdateStatus ? (
                                <Orderstatus
                                    className={"statusWrap bg-transparent custom-dropdown-no-caret"}
                                    disabled={currentOrder?.Redo || disabledRedo}
                                    statusesOptions={statusesOptions}
                                    value={formdata?.Status}
                                    onSelect={handleStatusChangeRequest}
                                />
                                ) : (
                                    (() => {
                                const status = getClassByType(formdata?.Status);
                                return (
                                    <span className={`${status.class} status-badge`}>
                                        <span className="borderBar pe-2 me-1">
                                            {formdata?.Status === 999 ? "999" : `0${formdata?.Status}`}
                                        </span>
                                        {status.title}
                                    </span>
                                );
                                    })()
                                )}
                                {currentOrder?.isDemo === true && (
                                    <span
                                        className="status-badge class-demo"
                                        title={
                                            currentOrder?.demoOptionLabel ||
                                            ({
                                                CAP1: "CAP-1",
                                                CAP2: "CAP-2",
                                                "CAP-1": "CAP-1",
                                                "CAP-2": "CAP-2",
                                                JUST_GLASSES: "Just Glasses",
                                                CAP2_BUNDLE: "CAP-2",
                                                PROCESSOR_ACCESSORY_KIT:
                                                    "Processor & Accessory Kit",
                                            }[
                                                String(
                                                    currentOrder?.demoOptionCode || ""
                                                ).toUpperCase()
                                            ] ||
                                                String(
                                                    currentOrder?.demoOptionCode ||
                                                        ""
                                                )
                                                    .split(",")
                                                    .map((code) =>
                                                        formatBundleDisplayLabel(
                                                            code
                                                        )
                                                    )
                                                    .filter(Boolean)
                                                    .join(", ") ||
                                                "Demo unit")
                                        }
                                    >
                                        Demo
                                    </span>
                                )}
                                {showApprovalStatus &&
                                    !isDemoOrder &&
                                    currentOrder?.channel === "va" && (
                                    <span className={`status-badge ${distributorApprovalStatus === "approved" ? "class-shipped" : "class-readyShip"}`}>
                                        {distributorApprovalStatus === "approved" ? "Approved" : "Pending"}
                                    </span>
                                )}
                                {showDistributorApproval &&
                                    !isDemoOrder &&
                                    currentOrder?.channel === "va" && (
                                    distributorApprovalStatus === "approved" ? (
                                        <span className="order-approved-pill">
                                            <ApprovedCheckSvg className="order-approved-pill__icon" />
                                            Approved
                                        </span>
                                    ) : (
                                        <Dropdown className="va-pending-review-dropdown">
                                            <Dropdown.Toggle
                                                id={`va-pending-review-${currentOrder?.ItemID || "order"}`}
                                                variant="unset"
                                                disabled={isApprovingOrder}
                                                className="va-pending-review-toggle"
                                            >
                                                <HourglassSvg className="va-pending-review-toggle__icon" />
                                                <span>
                                                    {isApprovingOrder
                                                        ? "Approving..."
                                                        : "Pending review"}
                                                </span>
                                                <ChevronDownSvg />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu align="end">
                                                <Dropdown.Item
                                                    onClick={openApproveConfirmModal}
                                                    disabled={isApprovingOrder}
                                                >
                                                    Mark as Approved
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    )
                                )}
                            </span>
                        )}
                        </li>

                    </ul>
                    </div>
            <div className="d-flex gap-3 order-details-layout">
                <ul className="product-menu ps-0">
                    {isBundleOrderView
                        ? bundleGroups.map((group) => {
                            const isActive = group.indices.includes(currentIndex);
                            const qty = Math.max(1, Number(group.quantity) || 1);
                            return (
                                <li
                                    key={group.key}
                                    role="button"
                                    className={`d-flex gap-2 align-items-center ${isActive ? "active" : ""}`}
                                    onClick={() => {
                                        if (dirty) return;
                                        const nextIndex = group.indices.includes(currentIndex)
                                            ? currentIndex
                                            : preferBundlePrimaryIndex(orders, group.indices);
                                        handleNavClick(nextIndex);
                                    }}
                                >
                                    <span className="flex-shrink-0 dothiglight rounded-5"></span>
                                    <span className="product-menu__bundle-label">
                                        {group.label}
                                    </span>
                                    {qty > 1 ? (
                                        <span
                                            className="product-menu__qty-badge"
                                            aria-label={`Quantity ${qty}`}
                                        >
                                            {qty}
                                        </span>
                                    ) : null}
                                </li>
                            );
                        })
                        : orders.map((OrderDetails, key) => (
                        <li
                            key={key}
                            role="button"
                            className={`d-flex gap-2 align-items-center ${key === currentIndex ? "active" : ""}`}
                            onClick={() => handleNavClick(key)}
                        >
                            <span className="flex-shrink-0 dothiglight rounded-5"></span>  {OrderDetails.ItemID}
                        </li>
                    ))}
                </ul>
                <div className="flex-grow-1 order-details-main">
                    

                    <div className="order-wrapper-scroll d-flex flex-column gap-3" ref={scrollContainerRef}>
                        {/* Shopify / legacy: list line items with activation code on Premium only */}
                        {!isBundleOrderView &&
                            !isVaChannel(currentOrder) &&
                            !isDemoOrder &&
                            !isVaDistributor?.() &&
                            orders.some((row) => isCaptifyPremiumOrderLine(row)) && (
                            <Card className="p-3 order-bundle-summary-card">
                                <ul className="order-bundle-components ps-0 mb-0">
                                    {(() => {
                                        let premiumSlot = 0;
                                        return orders.map((line, itemIndex) => {
                                            const isPremium = isCaptifyPremiumOrderLine(line);
                                            let redemptionCode = "";
                                            if (isPremium) {
                                                redemptionCode =
                                                    resolveOrderRedemptionCode(line, orders) ||
                                                    shopifyCodeByLineItemId.get(
                                                        String(line?.ShopifyItemID || "").trim()
                                                    ) ||
                                                    shopifyActivationCodes[premiumSlot] ||
                                                    "";
                                                premiumSlot += 1;
                                            }
                                            return (
                                                <li
                                                    key={line?.ItemID || itemIndex}
                                                    role="button"
                                                    className={`order-bundle-components__item ${
                                                        itemIndex === currentIndex ? "active" : ""
                                                    } ${
                                                        line?.isRemoved || line?.isReturned
                                                            ? "is-removed"
                                                            : ""
                                                    }`}
                                                    onClick={() => {
                                                        if (itemIndex !== currentIndex && !dirty) {
                                                            handleNavClick(itemIndex);
                                                        }
                                                    }}
                                                >
                                                    <span className="order-bundle-components__id">
                                                        {line?.ItemID}:
                                                    </span>
                                                    <span className="order-bundle-components__name">
                                                        {line?.SkuName || line?.ItemID}
                                                    </span>
                                                    {redemptionCode ? (
                                                        <span
                                                            className="order-bundle-components__code"
                                                            title="Activation code"
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            <span className="order-bundle-components__code-value">
                                                                {redemptionCode}
                                                            </span>
                                                            <CopyToClipboard
                                                                value={redemptionCode}
                                                                className="order-bundle-components__code-copy"
                                                            />
                                                        </span>
                                                    ) : null}
                                                </li>
                                            );
                                        });
                                    })()}
                                </ul>
                            </Card>
                        )}
                        {isBundleOrderView &&
                            activeBundleGroup &&
                            (activeBundleGroup.units?.length
                                ? activeBundleGroup.units
                                : [
                                      {
                                          key: activeBundleGroup.key,
                                          label: `Bundle: ${activeBundleGroup.label}`,
                                          unitIndex: 1,
                                          unitTotal: 1,
                                          indices: activeBundleGroup.indices,
                                      },
                                  ]
                            ).map((unit) => (
                            <Card
                                key={unit.key}
                                className="p-3 order-bundle-summary-card"
                            >
                                <div className="order-bundle-summary-card__title">
                                    {unit.label}
                                </div>
                                <ul className="order-bundle-components ps-0 mb-0">
                                    {unit.indices.map((itemIndex, positionInUnit) => {
                                        const line = orders[itemIndex];
                                        if (!line) return null;
                                        const isPremium = isCaptifyPremiumOrderLine(line);
                                        // VA / demo: hide in UI. Shopify legacy: show from Order or lookup.
                                        const redemptionCode =
                                            isPremium &&
                                            !isVaChannel(line) &&
                                            !isVaChannel(currentOrder) &&
                                            !isVaDistributor?.() &&
                                            !isDemoOrder
                                                ? resolveOrderRedemptionCode(line, orders) ||
                                                  shopifyCodeByLineItemId.get(
                                                      String(line?.ShopifyItemID || "").trim()
                                                  ) ||
                                                  shopifyActivationCodes[0] ||
                                                  ""
                                                : "";
                                        const displayItemId =
                                            formatBundleUnitItemDisplayId(
                                                line,
                                                unit.unitIndex,
                                                positionInUnit + 1,
                                                Math.max(
                                                    Number(unit.unitTotal) || 0,
                                                    Number(activeBundleGroup.quantity) || 1
                                                )
                                            ) || line.ItemID;
                                        return (
                                            <li
                                                key={line.ItemID || itemIndex}
                                                role="button"
                                                className={`order-bundle-components__item ${
                                                    itemIndex === currentIndex ? "active" : ""
                                                } ${
                                                    line?.isRemoved || line?.isReturned
                                                        ? "is-removed"
                                                        : ""
                                                }`}
                                                onClick={() => {
                                                    if (itemIndex !== currentIndex && !dirty) {
                                                        handleNavClick(itemIndex);
                                                    }
                                                }}
                                            >
                                                <span className="order-bundle-components__id">
                                                    {displayItemId}:
                                                </span>
                                                <span className="order-bundle-components__name">
                                                    {line.SkuName || line.ItemID}
                                                </span>
                                                {redemptionCode ? (
                                                    <span
                                                        className="order-bundle-components__code"
                                                        title="Activation code"
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <span className="order-bundle-components__code-value">
                                                            {redemptionCode}
                                                        </span>
                                                        <CopyToClipboard
                                                            value={redemptionCode}
                                                            className="order-bundle-components__code-copy"
                                                        />
                                                    </span>
                                                ) : null}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </Card>
                            ))}
                        {orders.map((order, index) => {
                            if (isBundleOrderView && index !== currentIndex) {
                                return null;
                            }
                            // Show prescription fields only when the item is a lens
                            // (i.e., when \"Item Ordered\" is set to Lens for that card).
                            const isItemShowFields = (index === currentIndex)
                                ? isLensProductType(formdata.ProductType)
                                : isLensProductType(order?.ProductType);

                            const latestTrackingForInactive = getLatestTrackingInfoForOrder(order.Tracking);

                            // Prepare display name for SKU + mount type without duplicating "Insert" text
                            const mountType = order?.LensMountType;
                            const normalizedMountType = mountType
                                ? mountType.charAt(0).toUpperCase() + mountType.slice(1)
                                : null;
                            let displaySkuName = order?.SkuName || "";
                            if (mountType && mountType.toLowerCase() === "inserts") {
                                // If SKU already ends with "- Insert", drop that part so UI shows only one "Inserts"
                                displaySkuName = displaySkuName.replace(/\s*-\s*Insert$/i, "");
                            } else if (mountType && mountType.toLowerCase() === "bonded") {
                                // If SKU already ends with "- Bonded", drop that part so UI shows only one "Bonded"
                                displaySkuName = displaySkuName.replace(/\s*-\s*Bonded$/i, "");
                            }

                            const itemProductType =
                                index === currentIndex
                                    ? formdata.ProductType ||
                                    resolveOrderItemProductType(order)
                                    : resolveOrderItemProductType(order);
                            const itemProductTypeValue =
                                displayProductTypeValue(itemProductType);
                            const isItemTypeBlank = isUnknownProductType(
                                itemProductTypeValue
                            );
                            const itemProductTypeForUi = itemProductTypeValue;
                            const isFrameOrOther =
                                isFrameProductType(itemProductTypeForUi) ||
                                isOtherProductType(itemProductTypeForUi);
                            const isCurrentItem = index === currentIndex;
                            const isReworkItem = isReworkItemId(order?.ItemID);
                            const assignment = order?.productionAssignment;
                            const latestArtsProcess = Array.isArray(order?.productionProcesses)
                                ? [...order.productionProcesses].sort((a, b) => new Date(b.occurredAt) - new Date(a.occurredAt))[0]
                                : null;
                            const latestArtsExpress = Array.isArray(order?.productionExpress)
                                ? order.productionExpress[order.productionExpress.length - 1]
                                : null;
                            const productionUpdatedAt = formatProductionTime(
                                assignment?.lastSyncedAt || latestArtsProcess?.occurredAt
                            );
                            const canSendToProduction = isLensProductType(itemProductTypeForUi)
                                && Number(order?.Status) === 2
                                && !order?.isRemoved
                                && (!order?.isReturned || isReworkItem);
                            const canRetryProduction = ["PP", "YUFENG"].includes(assignment?.provider)
                                && assignment?.status === "FAILED";
                            const providerLabel = { ARTS: "Arts", PP: "PrimeParticle", YUFENG: "Yufeng" };
                            const assignmentLabel = assignment?.provider
                                ? (assignment.status === "FAILED"
                                    ? "Send failed · Retry"
                                    : `Sent to ${providerLabel[assignment.provider] || assignment.provider}`)
                                : null;
                            const collapsedSummary = [
                                itemProductTypeValue,
                                order?.SkuName || order?.CaptifyVersion,
                            ].filter(Boolean).join(" · ");

                            if (!isCurrentItem && !isBundleOrderView) {
                                return (
                                    <Card
                                        key={order.ItemID}
                                        ref={(el) => { itemRefs.current[index] = el; }}
                                        data-index={index}
                                        className="collapsed-item-card"
                                    >
                                        <button
                                            type="button"
                                            className="collapsed-item-card-button"
                                            aria-expanded="false"
                                            disabled={dirty || order?.isRemoved}
                                            onClick={() => handleNavClick(index)}
                                        >
                                            <span className="collapsed-item-id">{order?.ItemID}</span>
                                            <span className="collapsed-item-summary">{collapsedSummary}</span>
                                            <span className="collapsed-item-action">Open</span>
                                            <AngleRightSvg />
                                        </button>
                                    </Card>
                                );
                            }

                            return (
                                <div
                                    key={order.ItemID}
                                    ref={(el) => {
                                        itemRefs.current[index] = el;
                                    }}
                                    data-index={index}
                                    className="order-item-card-anchor"
                                >
                                <Card
                                    className={`p-3 ${index === currentIndex ? 'active-item-card' : ''}`}
                                    onClick={() => {
                                        if (index !== currentIndex && !dirty) {
                                            handleNavClick(index);
                                        }
                                    }}
                                >
                                    <div>
                                        <ul className="d-flex align-items-center ps-0 gap-3">
                                                <li className="flex-grow-1">
                                                    {isBundleOrderView ? (
                                                        <div className="order-bundle-item-heading">
                                                            <span className="order-bundle-item-heading__name">
                                                                {order?.SkuName || order?.ItemID}
                                                            </span>
                                                            <span className="order-bundle-item-heading__id">
                                                                {order?.ItemID}
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        order?.ItemID
                                                    )}
                                                </li>
                                                <li className="production-actions">
                                                    {assignmentLabel && !canRetryProduction && (
                                                        <span className={`production-assignment-badge production-assignment-${assignment?.status?.toLowerCase()}`}>
                                                            {assignmentLabel}
                                                        </span>
                                                    )}
                                                    {canUpdateProperties && canSendToProduction && (
                                                        <CustomDropdown
                                                            className="production-provider-dropdown"
                                                            disabled={Boolean(sendingProductionItemId) || dirty}
                                                            label={sendingProductionItemId === order.ItemID
                                                                ? "Sending..."
                                                                : (canRetryProduction ? "Send failed · Retry" : assignment?.provider ? "Resend to" : "Send to")}
                                                            options={[
                                                                { label: "Send to Arts", value: "ARTS" },
                                                                { label: "Send to PrimeParticle", value: "PP" },
                                                                { label: "Send to Yufeng", value: "YUFENG" },
                                                            ]}
                                                            onSelect={(option) => handleSendToProduction(order, option.value, Boolean(assignment?.provider))}
                                                        />
                                                    )}
                                                </li>
                                            <li>
                                                {order?.isRemoved ? <span className="redoOnly">Removed from Shopify</span> :
                                                        isReworkItem ? null :
                                                        order?.isReturned ? (
                                                            <button
                                                                type="button"
                                                                className="redoOnly return-redo-button"
                                                                disabled={isUpdating}
                                                                onClick={() => handleReturnRedo(order)}
                                                            >
                                                                {isUpdating ? "Returning..." : "Return"}
                                                            </button>
                                                        ) :
                                                        order?.Redo ? <span className="redoOnly">Redo : {glassTypeLabels[order?.Redo]}</span> :
                                                            canRedo ? (
                                                            <Glassonly
                                                                        disabled={!canUpdateProperties || isItemTypeBlank || isOtherProductType(itemProductTypeForUi) || order?.Redo || order?.isRemoved || order?.isReturned}
                                                                label={"Select Redo"}
                                                                value={index === currentIndex ? initialRedo : order?.Redo}
                                                                onSelect={(option) => handleSelectRedo(option)}
                                                                        productType={itemProductTypeForUi}
                                                                skuName={order?.SkuName}
                                                            />
                                                            ) : null}

                                            </li>
                                        </ul>

                                            {assignment?.provider === "PP" && assignment?.externalOrderNo && (
                                                <div className="production-status-panel">
                                                    <span><strong>PrimeParticle order:</strong> {assignment.externalOrderNo}</span>
                                                    <span><strong>Status:</strong> {queryingProductionItemId === order.ItemID ? "Checking..." : formatProductionStatus(assignment.providerStatus || "pending")}</span>
                                                    {productionUpdatedAt && <span><strong>Updated:</strong> {productionUpdatedAt}</span>}
                                                    {assignment.providerExceptionStatus && assignment.providerExceptionStatus !== "none" && (
                                                        <span className="production-status-exception"><strong>Exception:</strong> {assignment.providerExceptionStatus}</span>
                                                    )}
                                                </div>
                                            )}
                                            {assignment?.provider === "ARTS" && (
                                                <div className="production-status-panel">
                                                    <span><strong>Arts production</strong></span>
                                                    <span><strong>Status:</strong> {formatProductionStatus(assignment.providerStatus || latestArtsProcess?.status || "Assigned")}</span>
                                                    {productionUpdatedAt && <span><strong>Updated:</strong> {productionUpdatedAt}</span>}
                                                    {latestArtsProcess?.remark && <span><strong>Remark:</strong> {latestArtsProcess.remark}</span>}
                                                    {latestArtsExpress?.expressNo && <span><strong>Tracking:</strong> {latestArtsExpress.expressNo}</span>}
                                                </div>
                                            )}
                                            {assignment?.provider === "YUFENG" && (
                                                <div className="production-status-panel">
                                                    <span><strong>Yufeng production</strong></span>
                                                    <span><strong>Status:</strong> {queryingProductionItemId === order.ItemID ? "Checking..." : formatProductionStatus(assignment.providerStatus || "Waiting for update")}</span>
                                                    {assignment.providerDescription && <span><strong>Description:</strong> {assignment.providerDescription}</span>}
                                                    {assignment.providerStatusAt && <span><strong>Status time:</strong> {formatProductionTime(assignment.providerStatusAt)}</span>}
                                                    {productionUpdatedAt && <span><strong>Checked:</strong> {productionUpdatedAt}</span>}
                                                </div>
                                            )}

                                        <ul className="mb-3 d-flex gap-2 flex-column basic-info ">
                                            <li className="info-text d-flex gap-3 align-items-center">
                                                    {isItemTypeBlank ? (
                                                    <>
                                                        <span>Item Ordered:</span>
                                                        <CustomDropdown
                                                            disabled={!canUpdateProperties || order?.Redo || order?.isRemoved || order?.isReturned || order?.Status === 999}
                                                                options={getProductTypeOptions()}
                                                                value={itemProductTypeValue || "unknown"}
                                                            onSelect={(opt) => handleSelect("ProductType", opt)}
                                                        />
                                                        {order?.SkuName}
                                                    </>
                                                ) : (
                                                        isFrameOrOther ? (

                                                        <>
                                                            <span>Product:</span>

                                                            <CustomDropdown
                                                                disabled
                                                                    options={getProductTypeOptions()}
                                                                    value={itemProductTypeValue}
                                                                onSelect={(opt) => handleSelect("ProductType", opt)}

                                                            />
                                                            {order?.SkuName}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <span>Item Ordered:</span>

                                                            <CustomDropdown
                                                                disabled
                                                                    options={getProductTypeOptions()}
                                                                    value={itemProductTypeValue}
                                                                onSelect={(opt) => handleSelect("ProductType", opt)}

                                                            />
                                                            {displaySkuName}
                                                            {normalizedMountType && ` - ${normalizedMountType}`}
                                                            {(skuUpdates !== null && skuUpdates.length > 0 && order.ItemID === currentOrder.ItemID) && skuUpdates?.some(u => u.isFieldSeen === false) && (
                                                                <div className="green-dot shrink-0"></div>
                                                            )}
                                                        </>
                                                    )
                                                )}
                                            </li>
                                            {/* {showCaptifyDropdown ? <li className="info-text d-flex gap-3 align-items-center"><span>Captify Version:</span> <div style={{ width: "180px" }}><CustomDropdown disabled={order?.Redo} options={[{ label: "Unknown", value: "Unknown" }, { label: "Captify Pro", value: "Captify Pro" }, { label: "Captify Myvu - Blue", value: "Captify Myvu - Blue" }, { label: "Captify Myvu - Black", value: "Captify Myvu - Black" }]} value={index === currentIndex ? (formdata.CaptifyVersion || "Unknown") : (order.CaptifyVersion || "Unknown")} onSelect={(opt) => handleSelect("CaptifyVersion", opt)} /></div> </li> :
                                                itemCaptifyVersion && <li className="info-text d-flex gap-3"><span>Captify Version:</span> {itemCaptifyVersion} </li>} */}

                                            <li className="info-text d-flex gap-3 align-items-center"><span>Captify Version:</span> <div style={{ width: "180px" }}>
                                                <CustomDropdown
                                                        disabled={
                                                            !canUpdateProperties ||
                                                            order?.Redo ||
                                                            order?.isRemoved ||
                                                            order?.isReturned ||
                                                            order?.Status === 999 ||
                                                            Boolean(
                                                                order?.CaptifyVersion &&
                                                                String(order.CaptifyVersion).trim() &&
                                                                String(order.CaptifyVersion).trim().toLowerCase() !== "unknown"
                                                            )
                                                        }
                                                        options={[{ label: "Unknown", value: "Unknown" }, { label: "Captify Pro", value: "Captify Pro" }, { label: "Captify Myvu - Blue", value: "Captify Myvu - Blue" }, { label: "Captify Myvu - Black", value: "Captify Myvu - Black" }, { label: "Captify Myvu", value: "Captify Myvu" }]}
                                                        value={index === currentIndex ? (formdata.CaptifyVersion || "Unknown") : (order.CaptifyVersion || "Unknown")} onSelect={(opt) => handleSelect("CaptifyVersion", opt)} />

                                            </div> </li>
                                        </ul>

                                        {isItemShowFields &&
                                            <>
                                                    <div className="d-flex justify-content-between mb-3 align-items-center gap-2 flex-wrap">
                                                        <h6 className="label-title mb-0">Prescription</h6>
                                                        {order?.prescriptionFile && (
                                                            <div className="d-flex align-items-center gap-3 flex-wrap">
                                                                <span
                                                                    role="button"
                                                        className="highlight cursor-pointer"
                                                        style={{ pointerEvents: "auto", cursor: "pointer", opacity: 1 }}
                                                        onClick={() => {
                                                            if (order?.prescriptionFile) {
                                                                window.open(order.prescriptionFile, "_blank", "noopener,noreferrer");
                                                            }
                                                        }}
                                                    >
                                                        <FileSvg />View prescription file
                                                                </span>
                                                                {index === currentIndex &&
                                                                    canUpdateProperties &&
                                                                    !order?.Redo &&
                                                                    !order?.isRemoved &&
                                                                    !order?.isReturned &&
                                                                    !disabledRedo &&
                                                                    order?.Status !== 999 && (
                                                                    <Button
                                                                        size="small"
                                                                        label="AI Extraction"
                                                                        className="order-details-ai-extract-btn"
                                                                        icon={<AiSparkleSvg color="#fff" />}
                                                                        onClick={handleAiExtractionClick}
                                                                        loading={isParsingRx}
                                                                        disabled={isParsingRx}
                                                                    />
                                                                )}
                                                            </div>
                                                        )}
                                                </div>

                                                <PrescriptionList listData={prescriptionData}
                                                    selectedOption={index === currentIndex ? selectedOption : (order.PDOneorTwoNumbers || "Two")}
                                                    setSelectedOption={setSelectedOption}
                                                    handleSelect={order?.Redo ? () => { } : handleSelect}
                                                    formValues={index === currentIndex ? formdata : order}
                                                    currentOrder={order}
                                                    disabled={!canUpdateProperties || index !== currentIndex || order?.Redo || order?.isRemoved || order?.isReturned || disabledRedo || order?.Status === 999}
                                                />
                                            </>
                                        }

                                        {isItemShowFields && <Row className="mb-3">
                                            <Col md={6} className="mb-3">
                                                <label className="label-title">Mount Type Made</label>
                                                <CustomDropdown
                                                    disabled={!canUpdateProperties || index !== currentIndex || order?.Redo || order?.isRemoved || order?.isReturned || order?.CaptifyVersion?.toLowerCase().includes("captify myvu")}
                                                    value={(
                                                        (index === currentIndex
                                                            ? formdata.LensMountType
                                                            : order?.LensMountType) || ""
                                                    ).toLowerCase()}
                                                    className="w-100"
                                                    options={[
                                                        { label: "Bonded", value: "bonded" },
                                                        { label: "Inserts", value: "inserts" }
                                                    ]}
                                                    onSelect={(option) => handleSelect("LensMountType", option)}
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <span className="label-title">Lens Batch</span>
                                                <div className="position-relative">
                                                    <input
                                                        disabled={!canUpdateProperties || index !== currentIndex || order?.Redo || order?.isRemoved || order?.isReturned}
                                                        type="text"
                                                        placeholder="Enter Lens Batch"
                                                        className="cp-input"
                                                        value={index === currentIndex ? formdata.LensList : order?.LensList}
                                                        onChange={(e) => handleInputChange("LensList", e.target.value)}
                                                    />
                                                    <span className="input-icon"><CopyToClipboard value={index === currentIndex ? formdata.LensList : order?.LensList} /></span>
                                                </div>
                                            </Col>
                                        </Row>}
                                            {!isRedemptionPanelOrder && (
                                        <Row className="mb-3">
                                            <Col md={6}>
                                                <span className="label-title">Shipping</span>
                                                    <CustomDatePicker
                                                        disabled={!canEditShipping || order?.Redo || order?.isRemoved || order?.isReturned}
                                                    value={index === currentIndex ? normalizeDate(formdata.ShipDate) : normalizeDate(latestShipDateAcrossOrder)}
                                                        onChange={(nextDate) => handleInputChange("ShipDate", nextDate)}
                                                        placeholder="dd-mm-yyyy"
                                                />
                                            </Col>
                                            <Col md={6}>
                                                <span className="opacity-0">Tracking Number</span>
                                                <div className="position-relative">
                                                    <input
                                                            disabled={!canEditShipping || order?.Redo || order?.isRemoved || order?.isReturned}
                                                        value={index === currentIndex ? (formdata.TrackingNumber || "") : latestTrackingForInactive.number}
                                                        type="text"
                                                        placeholder="Enter Tracking Number"
                                                        className="cp-input"
                                                        onChange={(e) => handleInputChange("TrackingNumber", e.target.value)}
                                                    />
                                                    <span className="input-icon"><CopyToClipboard value={index === currentIndex ? formdata.TrackingNumber : latestTrackingForInactive.number} /></span>
                                                </div>
                                            </Col>
                                        </Row>
                                            )}
                                            {isFrameProductType(itemProductTypeForUi) && Number(order.Quantity)>1 ? (
                                                <FrameUnits order={order} disabled={!canUpdateProperties || isUploadingPhoto || index !== currentIndex || order.Redo || order.isRemoved || order.isReturned} onSaved={() => fetchOrders({silent:true})}/>
                                            ) : (
                                            <section className="order-photo-section">
                                                <div className="order-photo-header">
                                                    <div>
                                                        <h6 className="label-title mb-1">
                                                            {isFrameProductType(itemProductTypeForUi) ? "Frame identification" : "Lens photos"}
                                                        </h6>
                                                        <span>
                                                            {isFrameProductType(itemProductTypeForUi)
                                                                ? `Recognize MAC and SN for ${order?.ItemID}`
                                                                : `Lens photos for ${order?.ItemID}`}
                                                        </span>
                                                    </div>
                                                    <Button
                                                        label={isUploadingPhoto
                                                            ? "Uploading..."
                                                            : `Take or choose ${isFrameProductType(itemProductTypeForUi) ? "frame" : "lens"} photo`}
                                                        icon={<UploadSvg />}
                                                        className="grey-btn order-photo-upload-button"
                                                        disabled={!canUpdateProperties || isUploadingPhoto || index !== currentIndex || order?.Redo || order?.isRemoved}
                                                        onClick={() => photoInputRef.current?.click()}
                                                    />
                                                    <input
                                                        ref={photoInputRef}
                                                        type="file"
                                                        accept="image/*"
                                                        className="visually-hidden"
                                                        onChange={handleOrderPhotoChange}
                                                    />
                                                </div>
                                                {isFrameProductType(itemProductTypeForUi) ? (
                                                    <div className="frame-identifier-inputs">
                                                        <label>
                                                            <span>MAC</span>
                                                            <input
                                                                type="text"
                                                                className="cp-input"
                                                                maxLength={17}
                                                                placeholder="AA:BB:CC:DD:EE:FF"
                                                                disabled={!canUpdateProperties || index !== currentIndex || order?.Redo || order?.isRemoved}
                                                                value={index === currentIndex ? (formdata.FrameMAC || "") : (order?.FrameMAC || "")}
                                                                onChange={(event) => handleInputChange("FrameMAC", event.target.value.toUpperCase())}
                                                                onBlur={(event) => handleInputChange("FrameMAC", formatMacAddress(event.target.value) || "")}
                                                            />
                                                        </label>
                                                        <label>
                                                            <span>SN</span>
                                                            <input
                                                                type="text"
                                                                className="cp-input"
                                                                maxLength={64}
                                                                placeholder="Enter serial number"
                                                                disabled={!canUpdateProperties || index !== currentIndex || order?.Redo || order?.isRemoved}
                                                                value={index === currentIndex ? (formdata.FrameSN || "") : (order?.FrameSN || "")}
                                                                onChange={(event) => handleInputChange("FrameSN", event.target.value.toUpperCase())}
                                                            />
                                                        </label>
                                                    </div>
                                                ) : order?.orderPhotos?.length > 0 ? (
                                                    <div className="order-photo-grid">
                                                        {order.orderPhotos.map((photo, photoIndex) => (
                                                            <a
                                                                key={photo?._id || `${photo?.url}-${photoIndex}`}
                                                                href={photo?.url}
                                                                target="_blank"
                                                                rel="noreferrer"
                                                                className="order-photo-item"
                                                            >
                                                                <img
                                                                    src={photo?.url}
                                                                    alt={`Lens ${order?.ItemID} photo ${photoIndex + 1}`}
                                                                    loading="lazy"
                                                                />
                                                            </a>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <p className="order-photo-empty mb-0">No lens photos uploaded.</p>
                                                )}
                                            </section>
                                            )}
                                    </div>
                                </Card>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className="addressInfo">
                    <YunexpressShipping id={id} onChanged={() => fetchOrders({silent:true})}/>
                    {showCancelOrderButton ? (
                        <button
                            type="button"
                            className="cancel-order-card mb-2"
                            disabled={
                                Boolean(currentOrder?.Redo) ||
                                disabledRedo ||
                                isUpdating ||
                                !isVaDistributorCancelAllowed ||
                                isOrderCancelled
                            }
                            onClick={openCancelConfirmModal}
                            aria-label="Cancel Order"
                        >
                            <CancelOrderSvg className="cancel-order-card__icon" />
                            <span>Cancel Order</span>
                        </button>
                    ) : null}
                    {Boolean(
                        customerOrder?.Address1 ||
                        customerOrder?.Address2 ||
                        customerOrder?.ShippingName ||
                        customerOrder?.ShippingCity ||
                        customerOrder?.ShippingCountry ||
                        customerOrder?.vaShipToRaw
                    ) && (
                    <>
                    <Overlay target={target.current} show={tooltipText} placement="top">
                        {(props) => (
                            <Tooltip id="overlay-example" {...props}>
                                Order status link copied
                            </Tooltip>
                        )}
                    </Overlay>
                    <div
                        ref={target}
                        className={`view-order-status-card mb-2${
                            currentOrder?.Redo || isUpdating || !trackingUrl
                                ? " is-disabled"
                                : ""
                        }`}
                    >
                        <button
                            type="button"
                            className="view-order-status-card__action"
                            disabled={
                                currentOrder?.Redo || isUpdating || !trackingUrl
                            }
                            onClick={() =>
                                window.open(
                                    trackingUrl,
                                    "_blank",
                                    "noopener,noreferrer"
                                )
                            }
                            aria-label="View Order Status"
                        >
                            <ViewOrderStatusSvg className="view-order-status-card__icon" />
                            <span>View Order Status</span>
                        </button>
                        <span
                            className="view-order-status-card__divider"
                            aria-hidden="true"
                        />
                        <button
                            type="button"
                            className="view-order-status-card__copy"
                            disabled={
                                currentOrder?.Redo || isUpdating || !trackingUrl
                            }
                            onClick={handleCopyUrl}
                            aria-label="Copy Order Status Link"
                        >
                            <FileCopySvg />
                        </button>
                    </div>
                    </>
                    )}
                    <UserInfo
                        currentOrder={customerOrder}
                        setShowAddnoteModal={setShowAddnoteModal}
                        setShowEditOrderFromModal={setShowEditOrderFromModal}
                        setShowEditCustomerModal={setShowEditCustomerModal}
                        canEditNotes={canEditNotes}
                        canEditCustomer={canUpdateProperties}
                        canEditOriginalPo={canManageVaDocs}
                        onOriginalPoUpdated={() => fetchOrders({ silent: true })}
                        onProviderNameSave={handleProviderNameSave}
                        providerNameSaving={isSavingProviderName}
                        hideCustomerDetails={isRedemptionPanelOrder}
                        hideRedemptionCode={
                            Boolean(isVaDistributor?.()) || isDemoOrder
                        }
                    />
                    <UserRecord RecordData={changeLogOrder} />

                </div>
                <CommonModal
                    show={showRedoConfirmModal}
                    setShow={setShowRedoConfirmModal}
                    title="Confirm Redo Action"
                    centered
                    className="modal-sm"
                    footer={
                        <CommonModalFooter>
                            <Button label="Yes, please keep it" size="lg" onClick={() => handleRedoConfirm(true)} />
                            <Button
                                label="No, I will reset it"
                                onClick={() => handleRedoConfirm(false)}
                                className="cancel"
                                size="lg"
                            />
                        </CommonModalFooter>
                    }
                >
                    <div className="commonBT pt-3 pb-3">
                        <div><strong>Would you like to keep the prescription and mount type?</strong></div>
                    </div>
                </CommonModal>
                <CommonModal
                    show={showStatusConfirmModal}
                    setShow={setShowStatusConfirmModal}
                    title="Confirm Status Change"
                    centered
                    className="modal-sm"
                    onConfirm={handleStatusConfirm}
                    onCancel={() => {
                        setShowStatusConfirmModal(false);
                        setStatusChangeAction(null);
                    }}
                >
                    <div className="commonBT pt-3 pb-3">
                        <div>
                            Are you sure you want to change the status to <strong>{statusToConfirm?.label}</strong>? If you change this status, the status of all items will be changed.
                        </div>
                    </div>
                </CommonModal>
                <CommonModal
                    show={showApproveConfirmModal}
                    setShow={setShowApproveConfirmModal}
                    title=""
                    centered
                    className="modal-sm order-approve-modal"
                    footer={
                        <CommonModalFooter className="order-approve-modal__actions" align="center">
                            <Button
                                label={isApprovingOrder ? "Approving..." : "Approve order"}
                                onClick={handleApproveConfirm}
                                className="order-approve-modal__confirm"
                                disabled={isApprovingOrder}
                                loading={isApprovingOrder}
                            />
                            <Button
                                label="Cancel"
                                onClick={() => setShowApproveConfirmModal(false)}
                                className="cancel order-approve-modal__cancel"
                                disabled={isApprovingOrder}
                            />
                        </CommonModalFooter>
                    }
                >
                    <div className="order-approve-modal__body">
                        <span className="order-approve-modal__icon" aria-hidden="true">
                            <CircleCheckSvg />
                        </span>
                        <h5 className="order-approve-modal__title">Approve this order?</h5>
                        <p className="order-approve-modal__text">
                            This marks the order as approved. You can still update other details afterward.
                        </p>
                    </div>
                </CommonModal>
                <CommonModal
                    show={showCancelConfirmModal}
                    setShow={(next) => {
                        if (!next) closeCancelConfirmModal();
                        else setShowCancelConfirmModal(true);
                    }}
                    title="Confirm order cancellation"
                    centered
                    className="modal-md"
                    confirmLabel="Cancel order"
                    cancelLabel="Keep order"
                    confirmDisabled={!cancelConfirmMatches || isUpdating}
                    confirmLoading={isUpdating}
                    onConfirm={handleCancelOrderConfirm}
                    onCancel={closeCancelConfirmModal}
                >
                    <div className="commonBT pt-3 pb-3">
                        <p className="mb-3">
                            This will cancel the entire order and cannot be undone easily.
                            To confirm, type the order number{" "}
                            <strong>{orderNumberForCancel || "—"}</strong> below.
                        </p>
                        <label className="label-title d-block mb-1" htmlFor="cancel-order-confirm-input">
                            Order number
                        </label>
                        <input
                            id="cancel-order-confirm-input"
                            type="text"
                            className="cp-input"
                            value={cancelConfirmText}
                            onChange={(e) => setCancelConfirmText(e.target.value)}
                            placeholder="Enter here"
                            autoComplete="off"
                            disabled={isUpdating}
                        />
                    </div>
                </CommonModal>
                <CommonModal
                    show={showAiExtractConfirmModal}
                    setShow={setShowAiExtractConfirmModal}
                    title="Run AI Extraction?"
                    centered
                    className="modal-sm"
                    confirmLabel="Yes, fill from file"
                    cancelLabel="Cancel"
                    confirmLoading={isParsingRx}
                    confirmDisabled={isParsingRx}
                    onConfirm={handleAiExtractConfirm}
                    onCancel={() => setShowAiExtractConfirmModal(false)}
                >
                    <div className="commonBT pt-3 pb-3">
                        <p className="mb-2">
                            AI will read the prescription file and fill in the
                            eye numbers (SPH, CYL, AXIS, ADD, and PD).
                        </p>
                        <p className="mb-0">
                            If any of those fields already have values, they
                            will be overwritten with what AI finds. You can
                            still check and edit everything before you save.
                        </p>
                    </div>
                </CommonModal>
                <CommonModal
                    show={showDeliveredBlockedModal}
                    setShow={setShowDeliveredBlockedModal}
                    title="Cannot change to Delivered"
                    centered
                    className="modal-sm"
                    footer={
                        <CommonModalFooter>
                            <Button
                                label="OK"
                                size="lg"
                                onClick={() => setShowDeliveredBlockedModal(false)}
                            />
                        </CommonModalFooter>
                    }
                >
                    <div className="commonBT pt-3 pb-3">
                        <div>
                            The order must be <strong>Shipped</strong> before its status can be
                            updated to <strong>Delivered</strong>.
                        </div>
                    </div>
                </CommonModal>
                <CommonModal
                    show={showProductTypeConfirmModal}
                    setShow={setShowProductTypeConfirmModal}
                    title="Confirm Item Type"
                    centered
                    className="modal-sm"
                    onConfirm={handleProductTypeSaveConfirm}
                    onCancel={() => setShowProductTypeConfirmModal(false)}
                >
                    <div className="commonBT pt-3 pb-3">
                        <div>
                            You are about to set Item Ordered to{" "}
                            <strong>{selectedProductTypeLabel}</strong>. After saving,
                            this selection will be locked and cannot be edited again.
                            Please confirm before continuing.
                        </div>
                    </div>
                </CommonModal>
            </div>
        </div>
    );
};

export default OrderDetails;
